
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("7k8Uw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");





var $jJf3a = parcelRequire("jJf3a");


var $hwNSM = parcelRequire("hwNSM");


var $iudHJ = parcelRequire("iudHJ");


var $kFwgS = parcelRequire("kFwgS");


var $aXWIB = parcelRequire("aXWIB");

const $186cb535f1e2b2f1$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $186cb535f1e2b2f1$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $186cb535f1e2b2f1$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $hwNSM.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $42omo.useState)(mode);
    (0, $42omo.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $42omo.useState)(spaceKey);
    const switchToViewPage = (0, $42omo.useCallback)(()=>{
        setCurrentMode((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $42omo.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
       * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
       */ if (currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && passThroughProps.contentId === modifiers.contentId) {
                    setCurrentMode((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $iudHJ.useExperienceTracker)();
    (0, $42omo.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
     * Using experienceTracker, we can switch from Edit to View page.
     * 1. When the user clicks the Publish button and task success, it can switch to the View page.
     *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
     *          change the spaceKey during publish.
     *          In that case, a new spaceKey will be added to the success event and tracked here.
     * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
     */ const isClosingPublishedEditPage = !draftShareId && name === $186cb535f1e2b2f1$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $186cb535f1e2b2f1$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJf3a.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ViewComponent, {
        navigationPolicy: pageNavigationPolicy,
        allowedFeatures: allowedFeatures.view,
        locale: locale,
        spaceKey: currentSpaceKey,
        showFooter: showFooter,
        ...passThroughProps
    }) : currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditComponent, {
        navigationPolicy: pageNavigationPolicy,
        allowedFeatures: allowedFeatures.edit,
        draftShareId: draftShareId,
        locale: locale,
        spaceKey: currentSpaceKey,
        ...passThroughProps
    }) : null);
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");

const $9ced22d459d44e84$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $elkSx.PageNotFoundEmptyState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $186cb535f1e2b2f1$export$6955bcca4cd3539f), props)));
module.exports["Page"] = $9ced22d459d44e84$export$6955bcca4cd3539f;

});

parcelRegister("jJf3a", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $519cb1da41ed4097$export$a7b0697657ed8bd0 = (0, $42omo.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});
module.exports["ExperienceTrackerContext"] = $519cb1da41ed4097$export$a7b0697657ed8bd0;

});

parcelRegister("hwNSM", function(module, exports) {


/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $42omo = parcelRequire("42omo");


var $8ce0W = parcelRequire("8ce0W");

function $da171e7c81d66b36$var$_extends() {
    $da171e7c81d66b36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $da171e7c81d66b36$var$_extends.apply(this, arguments);
} // Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $da171e7c81d66b36$export$3add0d5dce533e2e = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$145dfa71566a64dc = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$var$AwaitContext = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$26749e8557646306 = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$c7914228fb69b0f5 = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$9072aa6dd1f93057 = /*#__PURE__*/ $42omo.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $da171e7c81d66b36$var$RouteErrorContext = /*#__PURE__*/ $42omo.createContext(null);
function $da171e7c81d66b36$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $da171e7c81d66b36$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $8ce0W.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $da171e7c81d66b36$export$9c954a9d03d32f4a() {
    return $42omo.useContext($da171e7c81d66b36$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $da171e7c81d66b36$export$45d76561a5302f2b() {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    return $42omo.useContext($da171e7c81d66b36$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $da171e7c81d66b36$export$1b3f31771c5d07c() {
    return $42omo.useContext($da171e7c81d66b36$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $da171e7c81d66b36$export$6c330e8992e8a295(pattern) {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { pathname: pathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    return $42omo.useMemo(()=>(0, $8ce0W.matchPath)(pattern, (0, $8ce0W.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $da171e7c81d66b36$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $da171e7c81d66b36$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $42omo.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $da171e7c81d66b36$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $da171e7c81d66b36$var$useNavigateStable() : $da171e7c81d66b36$var$useNavigateUnstable();
}
function $da171e7c81d66b36$var$useNavigateUnstable() {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let dataRouterContext = $42omo.useContext($da171e7c81d66b36$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8ce0W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $42omo.useRef(false);
    $da171e7c81d66b36$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $42omo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $8ce0W.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8ce0W.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $da171e7c81d66b36$var$OutletContext = /*#__PURE__*/ $42omo.createContext(null); /**
                            * Returns the context (if provided) for the child route at this level of the route
                            * hierarchy.
                            * @see https://reactrouter.com/v6/hooks/use-outlet-context
                            */ 
function $da171e7c81d66b36$export$4138103a3ae699cc() {
    return $42omo.useContext($da171e7c81d66b36$var$OutletContext);
} /**
   * Returns the element for the child route at this level of the route
   * hierarchy. Used internally by `<Outlet>` to render child routes.
   *
   * @see https://reactrouter.com/v6/hooks/use-outlet
   */ 
function $da171e7c81d66b36$export$a3be3530d8e40d0b(context) {
    let outlet = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
} /**
   * Returns an object of key/value pairs of the dynamic params from the current
   * URL that were matched by the route path.
   *
   * @see https://reactrouter.com/v6/hooks/use-params
   */ 
function $da171e7c81d66b36$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
} /**
   * Resolves the pathname of the given `to` value against the current location.
   *
   * @see https://reactrouter.com/v6/hooks/use-resolved-path
   */ 
function $da171e7c81d66b36$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8ce0W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $42omo.useMemo(()=>(0, $8ce0W.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $da171e7c81d66b36$export$5d3fca4a98652595(routes, locationArg) {
    return $da171e7c81d66b36$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $da171e7c81d66b36$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { navigator: navigator } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: parentMatches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $da171e7c81d66b36$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $8ce0W.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $8ce0W.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $8ce0W.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $da171e7c81d66b36$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $8ce0W.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $8ce0W.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $da171e7c81d66b36$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $8ce0W.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $da171e7c81d66b36$var$DefaultErrorComponent() {
    let error = $da171e7c81d66b36$export$ed527bf60f6e05f2();
    let message = (0, $8ce0W.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $42omo.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $42omo.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $da171e7c81d66b36$var$defaultErrorElement = /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$DefaultErrorComponent, null);
class $da171e7c81d66b36$var$RenderErrorBoundary extends $42omo.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $da171e7c81d66b36$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $42omo.useContext($da171e7c81d66b36$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $da171e7c81d66b36$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $8ce0W.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    } // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i]; // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $da171e7c81d66b36$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $da171e7c81d66b36$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $42omo.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $da171e7c81d66b36$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($da171e7c81d66b36$var$DataRouterHook || {});
var $da171e7c81d66b36$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($da171e7c81d66b36$var$DataRouterStateHook || {});
function $da171e7c81d66b36$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $da171e7c81d66b36$var$useDataRouterContext(hookName) {
    let ctx = $42omo.useContext($da171e7c81d66b36$export$3add0d5dce533e2e);
    !ctx && (0, $8ce0W.UNSAFE_invariant)(false);
    return ctx;
}
function $da171e7c81d66b36$var$useDataRouterState(hookName) {
    let state = $42omo.useContext($da171e7c81d66b36$export$145dfa71566a64dc);
    !state && (0, $8ce0W.UNSAFE_invariant)(false);
    return state;
}
function $da171e7c81d66b36$var$useRouteContext(hookName) {
    let route = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    !route && (0, $8ce0W.UNSAFE_invariant)(false);
    return route;
} // Internal version with hookName-aware debugging
function $da171e7c81d66b36$var$useCurrentRouteId(hookName) {
    let route = $da171e7c81d66b36$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $8ce0W.UNSAFE_invariant)(false);
    return thisRoute.route.id;
} /**
   * Returns the ID for the nearest contextual route
   */ 
function $da171e7c81d66b36$export$5fc8298006ad9e58() {
    return $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseRouteId);
} /**
   * Returns the current navigation, defaulting to an "idle" navigation when
   * no navigation is in progress
   */ 
function $da171e7c81d66b36$export$d0fd4b7106de2769() {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
} /**
   * Returns a revalidate function for manually triggering revalidation, as well
   * as the current state of any manual revalidations
   */ 
function $da171e7c81d66b36$export$600dc272ed516c15() {
    let dataRouterContext = $da171e7c81d66b36$var$useDataRouterContext($da171e7c81d66b36$var$DataRouterHook.UseRevalidator);
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseRevalidator);
    return $42omo.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
} /**
   * Returns the active route matches, useful for accessing loaderData for
   * parent/child routes or the route "handle" property
   */ 
function $da171e7c81d66b36$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseMatches);
    return $42omo.useMemo(()=>matches.map((m)=>(0, $8ce0W.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
} /**
   * Returns the loader data for the nearest ancestor Route loader
   */ 
function $da171e7c81d66b36$export$1448a5050d252c4d() {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseLoaderData);
    let routeId = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
} /**
   * Returns the loaderData for the given routeId
   */ 
function $da171e7c81d66b36$export$fd5d37484eab868d(routeId) {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
} /**
   * Returns the action data for the nearest ancestor Route action
   */ 
function $da171e7c81d66b36$export$fdc00f3f26066d5e() {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseActionData);
    let routeId = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
} /**
   * Returns the nearest ancestor Route error, which could be a loader/action
   * error or a render error.  This is intended to be called from your
   * ErrorBoundary/errorElement to display a proper error message.
   */ 
function $da171e7c81d66b36$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $42omo.useContext($da171e7c81d66b36$var$RouteErrorContext);
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseRouteError);
    let routeId = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
} /**
   * Returns the happy-path data from the nearest ancestor `<Await />` value
   */ 
function $da171e7c81d66b36$export$78a72ddb39bdd145() {
    let value = $42omo.useContext($da171e7c81d66b36$var$AwaitContext);
    return value == null ? void 0 : value._data;
} /**
   * Returns the error from the nearest ancestor `<Await />` value
   */ 
function $da171e7c81d66b36$export$17f53340677d5831() {
    let value = $42omo.useContext($da171e7c81d66b36$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $da171e7c81d66b36$var$blockerId = 0; /**
                    * Allow the application to block navigations within the SPA and present the
                    * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
                    * using half-filled form data.  This does not handle hard-reloads or
                    * cross-origin navigations.
                    */ 
function $da171e7c81d66b36$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $da171e7c81d66b36$var$useDataRouterContext($da171e7c81d66b36$var$DataRouterHook.UseBlocker);
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $42omo.useState("");
    let blockerFunction = $42omo.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
         // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $da171e7c81d66b36$var$_extends({}, currentLocation, {
                pathname: (0, $8ce0W.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $da171e7c81d66b36$var$_extends({}, nextLocation, {
                pathname: (0, $8ce0W.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]); // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $42omo.useEffect(()=>{
        let key = String(++$da171e7c81d66b36$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]); // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $42omo.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]); // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $8ce0W.IDLE_BLOCKER);
} /**
   * Stable version of useNavigate that is used when we are in the context of
   * a RouterProvider.
   */ 
function $da171e7c81d66b36$var$useNavigateStable() {
    let { router: router } = $da171e7c81d66b36$var$useDataRouterContext($da171e7c81d66b36$var$DataRouterHook.UseNavigateStable);
    let id = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $42omo.useRef(false);
    $da171e7c81d66b36$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $42omo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $da171e7c81d66b36$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $da171e7c81d66b36$var$alreadyWarned$1 = {};
function $da171e7c81d66b36$var$warningOnce(key, cond, message) {
    if (!cond && !$da171e7c81d66b36$var$alreadyWarned$1[key]) $da171e7c81d66b36$var$alreadyWarned$1[key] = true;
}
const $da171e7c81d66b36$var$alreadyWarned = {};
function $da171e7c81d66b36$var$warnOnce(key, message) {}
const $da171e7c81d66b36$var$logDeprecation = (flag, msg, link)=>$da171e7c81d66b36$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $da171e7c81d66b36$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $da171e7c81d66b36$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $da171e7c81d66b36$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $da171e7c81d66b36$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $da171e7c81d66b36$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $da171e7c81d66b36$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $da171e7c81d66b36$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $da171e7c81d66b36$var$START_TRANSITION = "startTransition";
const $da171e7c81d66b36$var$startTransitionImpl = $42omo[$da171e7c81d66b36$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $da171e7c81d66b36$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $42omo.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $42omo.useCallback((newState)=>{
        if (v7_startTransition && $da171e7c81d66b36$var$startTransitionImpl) $da171e7c81d66b36$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $42omo.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $42omo.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $42omo.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $42omo.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $42omo.useEffect(()=>$da171e7c81d66b36$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $da171e7c81d66b36$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $da171e7c81d66b36$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $da171e7c81d66b36$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $42omo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8ce0W.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $42omo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $42omo.useCallback((newState)=>{
        v7_startTransition && $da171e7c81d66b36$var$startTransitionImpl ? $da171e7c81d66b36$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $42omo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $42omo.useEffect(()=>$da171e7c81d66b36$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $da171e7c81d66b36$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    let navigate = $da171e7c81d66b36$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $8ce0W.resolveTo)(to, (0, $8ce0W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $42omo.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $da171e7c81d66b36$export$910ae8079b2c2852(props) {
    return $da171e7c81d66b36$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $da171e7c81d66b36$export$e7b0ac011bb776c6(_props) {
    (0, $8ce0W.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $da171e7c81d66b36$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $8ce0W.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $42omo.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $da171e7c81d66b36$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $8ce0W.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $42omo.useMemo(()=>{
        let trailingPathname = (0, $8ce0W.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $da171e7c81d66b36$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $da171e7c81d66b36$export$5d3fca4a98652595($da171e7c81d66b36$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $da171e7c81d66b36$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$ResolveAwait, null, children));
}
var $da171e7c81d66b36$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($da171e7c81d66b36$var$AwaitRenderStatus || {});
const $da171e7c81d66b36$var$neverSettledPromise = new Promise(()=>{});
class $da171e7c81d66b36$var$AwaitErrorBoundary extends $42omo.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $da171e7c81d66b36$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $da171e7c81d66b36$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $da171e7c81d66b36$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $da171e7c81d66b36$var$AwaitRenderStatus.error : "_data" in promise ? $da171e7c81d66b36$var$AwaitRenderStatus.success : $da171e7c81d66b36$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $da171e7c81d66b36$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.error && promise._error instanceof (0, $8ce0W.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $da171e7c81d66b36$var$neverSettledPromise;
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $da171e7c81d66b36$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $da171e7c81d66b36$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $da171e7c81d66b36$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $42omo.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $42omo.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $42omo.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $da171e7c81d66b36$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $da171e7c81d66b36$export$e7b0ac011bb776c6) && (0, $8ce0W.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $8ce0W.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $da171e7c81d66b36$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $da171e7c81d66b36$export$daf73786167a7f72(matches) {
    return $da171e7c81d66b36$var$_renderMatches(matches);
}
function $da171e7c81d66b36$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $42omo.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $42omo.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $42omo.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $da171e7c81d66b36$export$f30f7e456d254e83(routes, opts) {
    return (0, $8ce0W.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $da171e7c81d66b36$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8ce0W.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $da171e7c81d66b36$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $lw2XG = parcelRequire("lw2XG");


var $hpNab = parcelRequire("hpNab");


var $kFwgS = parcelRequire("kFwgS");


var $jNfGN = parcelRequire("jNfGN");

function $fcb425ff61c316c2$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $fcb425ff61c316c2$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $fcb425ff61c316c2$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $lw2XG.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $fcb425ff61c316c2$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $jNfGN.VIEW_PAGE).name:
        case (0, $jNfGN.VIEW_BLOG).name:
        case (0, $jNfGN.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $jNfGN.EDIT_PAGE_EMBED).name:
        case (0, $jNfGN.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $jNfGN.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $jNfGN.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $fcb425ff61c316c2$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $fcb425ff61c316c2$var$findAndMatchRoute((0, $jNfGN.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $jNfGN.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $fcb425ff61c316c2$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $fcb425ff61c316c2$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $fcb425ff61c316c2$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $fcb425ff61c316c2$var$matchUrl(pattern, url) {
    if (!$fcb425ff61c316c2$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $8ce0W.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $8ce0W.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $fcb425ff61c316c2$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $hpNab.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $fcb425ff61c316c2$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}
module.exports["parsePageProps"] = $fcb425ff61c316c2$export$41eb0a358b69a9df;
module.exports["parseUrl"] = $fcb425ff61c316c2$export$7a5253c0f62e0150;

});

parcelRegister("iudHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9tntP = parcelRequire("9tntP");

var $jJf3a = parcelRequire("jJf3a");





var $inPa6 = parcelRequire("inPa6");


var $7pThu = parcelRequire("7pThu");


var $kquTo = parcelRequire("kquTo");


var $4HiV7 = parcelRequire("4HiV7");

const $680949b428819f6f$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $7pThu.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $kquTo.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $4HiV7.ANALYTICS_CHANNEL));
    });
    (0, $42omo.useEffect)(()=>unsubscribeRef.current, []);
};


function $050604c2cae7bb2b$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}


function $a32c46ee326387bc$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $42omo.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $9tntP.ExperienceTracker)();
    (0, $680949b428819f6f$export$e955abb82869dc84)(embeddedConfluenceETRef.current);
    $a32c46ee326387bc$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $a32c46ee326387bc$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $42omo.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $42omo.useRef)();
    const embeddingProductET = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $050604c2cae7bb2b$export$7ecf150f65423c3f)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $42omo.useEffect)(()=>unsubscribeRef.current, []);
};
module.exports["useExperienceTracker"] = $a32c46ee326387bc$export$cdefb2a8b53f879f;

});

parcelRegister("7pThu", function(module, exports) {
const $21fcdb9e1f147260$export$b9fadc635fed6276 = 'embedded-confluence/';
var $21fcdb9e1f147260$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $21fcdb9e1f147260$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $21fcdb9e1f147260$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});
module.exports["EXPERIENCE_NAME_PREFIX"] = $21fcdb9e1f147260$export$b9fadc635fed6276;
module.exports["ExperienceNames"] = $21fcdb9e1f147260$export$312b1a9f1141bdaa;
module.exports["ExperienceReasons"] = $21fcdb9e1f147260$export$db5add30a8721c38;
module.exports["SupportedExperienceNames"] = $21fcdb9e1f147260$export$ce9b20b2ad3e7bc6;

});

parcelRegister("4HiV7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");

const $2a57b7cce69b51d2$var$ANALYTICS_PRODUCT = 'embeddedConfluence';
const $2a57b7cce69b51d2$var$defaultOrgId = '';
const $2a57b7cce69b51d2$var$orgIdQuery = `query OrgId($hostNames: [String!]) {
    tenantContexts(hostNames: $hostNames) {
      orgId
    }
  }`;
const $2a57b7cce69b51d2$var$getAGGOrgId = async (hostname)=>{
    let orgId = $2a57b7cce69b51d2$var$defaultOrgId; // default value set to empty string for orgid when no orgid exists
    const prefix = `${window.location.protocol}//${hostname || window.location.hostname}`;
    try {
        const response = await fetch(`${prefix}/gateway/api/graphql`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $2a57b7cce69b51d2$var$orgIdQuery,
                variables: {
                    hostNames: [
                        hostname
                    ]
                }
            })
        });
        const result = await response.json();
        orgId = result.data?.tenantContexts[0]?.orgId ?? $2a57b7cce69b51d2$var$defaultOrgId;
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error fetching orgId from ${hostname}/gateway/api/graphql`);
    }
    return orgId;
};
// Define default analytic-web-client environment config for now
const $2a57b7cce69b51d2$var$getAnalyticsEnv = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
let $2a57b7cce69b51d2$var$analyticsClient;
const $2a57b7cce69b51d2$var$getUserInfo = async (hostname, userInfo)=>{
    if (userInfo) return {
        userId: userInfo?.userId,
        userIdType: userInfo?.userIdType
    };
    else {
        const prefix = `${window.location.protocol}//${hostname || window.location.hostname}`;
        const res = await fetch(`${prefix}/gateway/api/me`);
        const resJson = await res.json();
        const { account_id: account_id, account_type: account_type } = resJson;
        return account_type === 'atlassian' ? {
            userId: account_id,
            userIdType: (0, $5DUgU.userType).ATLASSIAN_ACCOUNT
        } : undefined;
    }
};
const $2a57b7cce69b51d2$export$e9ba7ef9458d1a4a = async ({ hostname: hostname, userInfo: userInfo })=>{
    if (!$2a57b7cce69b51d2$var$analyticsClient) {
        $2a57b7cce69b51d2$var$analyticsClient = new (0, $a9sR2.default)({
            product: $2a57b7cce69b51d2$var$ANALYTICS_PRODUCT,
            env: $2a57b7cce69b51d2$var$getAnalyticsEnv(hostname || window.location.hostname),
            origin: (0, $5DUgU.originType).WEB
        });
        try {
            const orgId = await $2a57b7cce69b51d2$var$getAGGOrgId(hostname);
            $2a57b7cce69b51d2$var$analyticsClient.setOrgInfo(orgId);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error); // orgId is not set when undefined or empty string based on current impl of setOrgInfo
        }
        try {
            const fetchedUserInfo = await $2a57b7cce69b51d2$var$getUserInfo(hostname, userInfo);
            if (fetchedUserInfo) $2a57b7cce69b51d2$var$analyticsClient.setUserInfo(fetchedUserInfo.userIdType, fetchedUserInfo.userId);
        } catch  {
            // eslint-disable-next-line no-console
            console.error(`Error fetching userInfo from ${hostname}/gateway/api/me`);
        }
    }
    return $2a57b7cce69b51d2$var$analyticsClient;
};


const $26eead0df01055f8$export$85183a312807388d = 'embeddedConfluence';
const $26eead0df01055f8$var$packageName = "platform-pkg";
const $26eead0df01055f8$var$packageVersion = "0.0.0-use.local";
const $26eead0df01055f8$var$AnalyticsListener = ({ children: children, embeddedConfluenceSource: embeddedConfluenceSource, hostname: hostname, parentProduct: parentProduct, userInfo: userInfo })=>{
    const [analyticsClient, setAnalyticsClient] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        (0, $2a57b7cce69b51d2$export$e9ba7ef9458d1a4a)({
            hostname: hostname,
            userInfo: userInfo
        }).then((res)=>{
            setAnalyticsClient(res);
        });
    }, [
        hostname,
        userInfo
    ]);
    const onEvent = (0, $42omo.useCallback)(({ payload: payload })=>{
        analyticsClient?.onEvent?.($26eead0df01055f8$export$85183a312807388d, {
            ...payload,
            attributes: {
                ...payload?.attributes,
                embeddedConfluenceSource: embeddedConfluenceSource,
                packageName: $26eead0df01055f8$var$packageName,
                packageVersion: $26eead0df01055f8$var$packageVersion,
                parentProduct: parentProduct
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        embeddedConfluenceSource
    ]);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: $26eead0df01055f8$export$85183a312807388d,
        onEvent: onEvent
    }, children);
};
var $26eead0df01055f8$export$2e2bcd8739ae039 = $26eead0df01055f8$var$AnalyticsListener;
module.exports["ANALYTICS_CHANNEL"] = $26eead0df01055f8$export$85183a312807388d;
module.exports["default"] = $26eead0df01055f8$export$2e2bcd8739ae039;

});

parcelRegister("elkSx", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");




const $130194087263f90e$var$messages = (0, $aXWIB.defineMessages)({
    pageNotFoundImageAriaLabel: {
        defaultMessage: "Page not found",
        id: "embedded-confluence-common.src.content.page-not-found-image.aria-label"
    },
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: "embedded-confluence-common.src.content.empty-state-header"
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: "embedded-confluence-common.src.content.empty-state-description"
    }
});
var $130194087263f90e$export$2e2bcd8739ae039 = $130194087263f90e$var$messages;


var $f6b11371bbd98277$exports = {};
$f6b11371bbd98277$exports = new URL("PageNotFoundSVG.5a354fce.svg", import.meta.url).toString();


const $599be2d733b06da7$var$styles = {
    image: "_p12f1mjv _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $599be2d733b06da7$var$PageNotFoundSVG = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f6b11371bbd98277$exports))),
        alt: formatMessage((0, $130194087263f90e$export$2e2bcd8739ae039).pageNotFoundImageAriaLabel),
        width: "476.06",
        height: "482.63"
    });
}; // Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const $599be2d733b06da7$var$PreviewPanelPageNotFoundSVG = ()=>{
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $599be2d733b06da7$var$styles.image
    }, /*#__PURE__*/ $42omo.createElement($599be2d733b06da7$var$PageNotFoundSVG, null));
};
const $599be2d733b06da7$export$d3ec4d3c4e3e468c = ({ embeddedConfluenceSource: embeddedConfluenceSource } = {})=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
    const EmptyStateImage = isInPreviewPanel ? $599be2d733b06da7$var$PreviewPanelPageNotFoundSVG : $599be2d733b06da7$var$PageNotFoundSVG;
    const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';
    return /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
        header: formatMessage((0, $130194087263f90e$export$2e2bcd8739ae039).emptyStateHeader),
        description: formatMessage((0, $130194087263f90e$export$2e2bcd8739ae039).emptyStateDescription),
        width: EmptyStateWidth,
        renderImage: ()=>/*#__PURE__*/ $42omo.createElement(EmptyStateImage, null)
    });
};
module.exports["PageNotFoundEmptyState"] = $599be2d733b06da7$export$d3ec4d3c4e3e468c;

});

parcelRegister("gt5FF", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $770972d787cabaf7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.connect-to-confluence.button': "P\u0159ipojit Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Tla\u010D\xedtko P\u0159ipojit Confluence",
    'embedded.confluence.connect-to-confluence.description': "Ukl\xe1dejte n\xe1pady, sledujte polo\u017Eky agendy a d\u011Blejte si pozn\xe1mky spole\u010Dn\u011B jako t\xfdm.",
    'embedded.confluence.connect-to-confluence.heading': "P\u0159ipojit ke Confluence",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};


var $773347a5ecc0b550$export$2e2bcd8739ae039 = (0, $770972d787cabaf7$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $1fbac85b0fe8f9ef$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.connect-to-confluence.button': 'Forbind Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Knappen Forbind Confluence',
    'embedded.confluence.connect-to-confluence.description': "Gem ideer, f\xf8lg dagsordenspunkter, og tag noter sammen som et team.",
    'embedded.confluence.connect-to-confluence.heading': 'Opret forbindelse til Confluence',
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};


var $4b444f9ddec14a5d$export$2e2bcd8739ae039 = (0, $1fbac85b0fe8f9ef$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $faec8ebf3b2cca76$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.connect-to-confluence.button': 'Confluence verbinden',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Schaltfl\xe4che "Confluence verbinden"',
    'embedded.confluence.connect-to-confluence.description': 'Halten Sie Ideen fest, verfolgen Sie Agendapunkte und machen Sie sich im Team Notizen.',
    'embedded.confluence.connect-to-confluence.heading': 'Mit Confluence verbinden',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};


var $14eaab80d38a0ee6$export$2e2bcd8739ae039 = (0, $faec8ebf3b2cca76$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $06c9811120bf1758$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.connect-to-confluence.button': 'Connect Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Connect Confluence Button',
    'embedded.confluence.connect-to-confluence.description': 'Save ideas, track agenda items, and take notes together as a team.',
    'embedded.confluence.connect-to-confluence.heading': 'Connect to Confluence',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};


var $865d855a1fa5d471$export$2e2bcd8739ae039 = (0, $06c9811120bf1758$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $25e67390bb758506$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.connect-to-confluence.button': 'Connect Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Connect Confluence Button',
    'embedded.confluence.connect-to-confluence.description': 'Save ideas, track agenda items, and take notes together as a team.',
    'embedded.confluence.connect-to-confluence.heading': 'Connect to Confluence',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};


var $6c55c06d45f02d30$export$2e2bcd8739ae039 = (0, $25e67390bb758506$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $43028ba70317978e$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.connect-to-confluence.button': "\u2063\u2062Connect Confluence\x90\u200D\x8f\u200D\u200D\x9d\x8d\u200C\u200C\x8f\u206D\u206D\u206B\x9d\u061C\x9d\u206A\u2061\u200C\u206F\x9d\u206B\u061C\u2061\u206D\u206C\x81\u206F\u061C\u206A\u206A\u206D\u2063\u2064",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u2063\u2062Connect Confluence Button\x81\u206C\u2061\u200D\x9d\x9d\u2060\u206C\x81\u206A\u2060\u206E\x8f\u206A\u206B\u206B\u200D\x8f\u200C\u206D\u206F\x81\x8d\u206E\u206E\u200C\u2060\u206F\x8f\u206D\u200D\u2060\u2063\u2064",
    'embedded.confluence.connect-to-confluence.description': "\u2063\u2062Save ideas, track agenda items, and take notes together as a team.\u206D\u206B\u2060\u2061\u200D\u200C\u061C\x81\u2060\x8f\u200D\x90\x90\u206C\u2061\u206B\u206A\u206B\u061C\x81\u206D\x90\u206B\u206D\u2061\u206C\u2060\u206C\u061C\u2061\u206F\u2061\u2063\u2064",
    'embedded.confluence.connect-to-confluence.heading': "\u2063\u2062Connect to Confluence\x8d\u206A\u206F\u206F\u061C\x81\u200C\u2061\x8d\u2060\u200D\u206C\x8d\x9d\u061C\u206C\u200C\u206D\x90\u206D\u061C\u200D\u2060\x90\u206A\u200C\u206C\x8f\x8d\u061C\u061C\x8d\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};


var $a9c1813fe7e4af9d$export$2e2bcd8739ae039 = (0, $43028ba70317978e$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $b061fd8aff37e484$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.connect-to-confluence.button': 'Conectarse a Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': "Bot\xf3n de conexi\xf3n a Confluence",
    'embedded.confluence.connect-to-confluence.description': "Guarda ideas, realiza un seguimiento de los puntos del orden del d\xeda y toma notas en equipo.",
    'embedded.confluence.connect-to-confluence.heading': 'Conectarse a Confluence',
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};


var $e36d3bdbd9bcfbc6$export$2e2bcd8739ae039 = (0, $b061fd8aff37e484$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $ecd1f7d292ef1208$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.connect-to-confluence.button': "Yhdist\xe4 Confluenceen",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Yhdist\xe4 Confluenceen \u2011painike",
    'embedded.confluence.connect-to-confluence.description': "Tallenna ideoita, seuraa esityslistan kohteita ja tee muistiinpanoja tiimin\xe4.",
    'embedded.confluence.connect-to-confluence.heading': "Yhdist\xe4 Confluenceen",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};


var $a53fe41909f30ebd$export$2e2bcd8739ae039 = (0, $ecd1f7d292ef1208$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ce7e2f0f781940c8$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.connect-to-confluence.button': "Connecter \xe0 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Bouton Connecter \xe0 Confluence",
    'embedded.confluence.connect-to-confluence.description': "Enregistrez des id\xe9es, suivez les points de l'ordre du jour et prenez des notes en \xe9quipe.",
    'embedded.confluence.connect-to-confluence.heading': "Connecter \xe0 Confluence",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};


var $cee97febb9adf70f$export$2e2bcd8739ae039 = (0, $ce7e2f0f781940c8$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $86e0fa8f65d81e65$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.connect-to-confluence.button': "Confluence csatlakoztat\xe1sa",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Confluence csatlakoztat\xe1sa gomb",
    'embedded.confluence.connect-to-confluence.description': "Csapatk\xe9nt menthetitek az \xf6tleteket, nyomon k\xf6vethetitek a napirendi pontokat \xe9s jegyzetelhettek.",
    'embedded.confluence.connect-to-confluence.heading': "Csatlakoz\xe1s a Confluence-hez",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};


var $4fd5ea0e4e732beb$export$2e2bcd8739ae039 = (0, $86e0fa8f65d81e65$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $b20f747ff4d27782$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.connect-to-confluence.button': 'Connetti Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Pulsante Connetti Confluence',
    'embedded.confluence.connect-to-confluence.description': "Memorizza le idee, monitora le voci all'ordine del giorno e prendi appunti insieme ai colleghi del team.",
    'embedded.confluence.connect-to-confluence.heading': 'Connetti a Confluence',
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};


var $fe343340a045571b$export$2e2bcd8739ae039 = (0, $b20f747ff4d27782$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $dc55569a1eabd9b6$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.connect-to-confluence.button': "Confluence \u306B\u63A5\u7D9A",
    'embedded.confluence.connect-to-confluence.button.aria-label': '"Confluence \u306B\u63A5\u7D9A" \u30DC\u30BF\u30F3',
    'embedded.confluence.connect-to-confluence.description': "\u30C1\u30FC\u30E0\u3067\u5354\u529B\u3057\u3066\u30A2\u30A4\u30C7\u30A2\u3092\u4FDD\u5B58\u3057\u3001\u8B70\u984C\u9805\u76EE\u3092\u8FFD\u8DE1\u3057\u3066\u30E1\u30E2\u3092\u53D6\u308A\u307E\u3057\u3087\u3046\u3002",
    'embedded.confluence.connect-to-confluence.heading': "Confluence \u306B\u63A5\u7D9A\u3059\u308B",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};


var $fc6992a6d33f0da5$export$2e2bcd8739ae039 = (0, $dc55569a1eabd9b6$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $7b7ae6970e843014$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.connect-to-confluence.button': "Confluence \uC5F0\uACB0",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Confluence \uC5F0\uACB0 \uBC84\uD2BC",
    'embedded.confluence.connect-to-confluence.description': "\uD55C \uD300\uC73C\uB85C \uD568\uAED8 \uC544\uC774\uB514\uC5B4\uB97C \uC800\uC7A5\uD558\uACE0 \uC5B4\uC820\uB354 \uD56D\uBAA9\uC744 \uCD94\uC801\uD558\uBA70 \uBA54\uBAA8\uB97C \uC791\uC131\uD569\uB2C8\uB2E4.",
    'embedded.confluence.connect-to-confluence.heading': "Confluence\uC5D0 \uC5F0\uACB0",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};


var $0433a47f9fb8dcfc$export$2e2bcd8739ae039 = (0, $7b7ae6970e843014$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $3d61379279fb7978$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.connect-to-confluence.button': 'Koble til Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': "Knapp for \xe5 koble til Confluence",
    'embedded.confluence.connect-to-confluence.description': "Lagre id\xe9er, spor elementer fra dagsordenen og ta notater sammen som et team.",
    'embedded.confluence.connect-to-confluence.heading': 'Koble til Confluence',
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};


var $746f02eed1044242$export$2e2bcd8739ae039 = (0, $3d61379279fb7978$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $427e9bf382879429$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.connect-to-confluence.button': 'Confluence koppelen',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Knop Confluence koppelen',
    'embedded.confluence.connect-to-confluence.description': "Bewaar idee\xebn, houd agenda-items bij en maak samen aantekeningen als team.",
    'embedded.confluence.connect-to-confluence.heading': 'Koppelen aan Confluence',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};


var $a7633fcbda8fb655$export$2e2bcd8739ae039 = (0, $427e9bf382879429$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $0cff0319137b1b7e$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.connect-to-confluence.button': "Po\u0142\u0105cz Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Przycisk Po\u0142\u0105cz Confluence",
    'embedded.confluence.connect-to-confluence.description': "Zapisuj pomys\u0142y, \u015Bled\u017A elementy agendy i\xa0r\xf3b notatki wsp\xf3lnie jako zesp\xf3\u0142.",
    'embedded.confluence.connect-to-confluence.heading': "\u0141\u0105czenie z\xa0Confluence",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};


var $44b404dcb1fc48a7$export$2e2bcd8739ae039 = (0, $0cff0319137b1b7e$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $a94647d63e99be1c$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.connect-to-confluence.button': 'Conectar ao Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': "Bot\xe3o de conectar ao Confluence",
    'embedded.confluence.connect-to-confluence.description': "Salve ideias, acompanhe itens da agenda e fa\xe7a anota\xe7\xf5es em equipe.",
    'embedded.confluence.connect-to-confluence.heading': 'Conectar ao Confluence',
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};


var $91dadffec46da81e$export$2e2bcd8739ae039 = (0, $a94647d63e99be1c$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $3f545fe5823c593a$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.connect-to-confluence.button': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \xab\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence\xbb",
    'embedded.confluence.connect-to-confluence.description': "\u0424\u0438\u043A\u0441\u0438\u0440\u0443\u0439\u0442\u0435 \u0438\u0434\u0435\u0438, \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043F\u0443\u043D\u043A\u0442\u044B \u043F\u043E\u0432\u0435\u0441\u0442\u043A\u0438 \u0434\u043D\u044F \u0438 \u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0437\u0430\u043C\u0435\u0442\u043A\u0438 \u0432\u0441\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'embedded.confluence.connect-to-confluence.heading': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u0441\u044C \u043A Confluence",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};


var $f2ebe896db83eed6$export$2e2bcd8739ae039 = (0, $3f545fe5823c593a$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $34e7fd9a8ca859a8$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.connect-to-confluence.button': 'Anslut till Confluence',
    'embedded.confluence.connect-to-confluence.button.aria-label': 'Knappen Anslut till Confluence',
    'embedded.confluence.connect-to-confluence.description': "Spara id\xe9er, sp\xe5ra dagordningspunkter och anteckna tillsammans som ett team.",
    'embedded.confluence.connect-to-confluence.heading': 'Anslut till Confluence',
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};


var $e47846e1ecea23cd$export$2e2bcd8739ae039 = (0, $34e7fd9a8ca859a8$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $946e420301e09504$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.connect-to-confluence.button': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1B\u0E38\u0E48\u0E21 Confluence",
    'embedded.confluence.connect-to-confluence.description': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E44\u0E2D\u0E40\u0E14\u0E35\u0E22 \u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E27\u0E32\u0E23\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E41\u0E25\u0E30\u0E08\u0E14\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E14\u0E49\u0E27\u0E22\u0E01\u0E31\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E21",
    'embedded.confluence.connect-to-confluence.heading': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};


var $7725b2b070b751bc$export$2e2bcd8739ae039 = (0, $946e420301e09504$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $0e582826fbc9fc61$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.connect-to-confluence.button': "Confluence'\u0131 Ba\u011Fla",
    'embedded.confluence.connect-to-confluence.button.aria-label': "Confluence'\u0131 Ba\u011Fla D\xfc\u011Fmesi",
    'embedded.confluence.connect-to-confluence.description': "Fikirleri kaydedin, g\xfcndem \xf6\u011Felerini takip edin ve tak\u0131m olarak birlikte not al\u0131n.",
    'embedded.confluence.connect-to-confluence.heading': "Confluence'a ba\u011Flan",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};


var $ed36669dfc29feb4$export$2e2bcd8739ae039 = (0, $0e582826fbc9fc61$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $46c750dbfcb62780$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.connect-to-confluence.button': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \xab\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 Confluence\xbb",
    'embedded.confluence.connect-to-confluence.description': "\u0420\u0430\u0437\u043E\u043C \u0456\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0439\u0442\u0435 \u0456\u0434\u0435\u0457, \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0439\u0442\u0435 \u043F\u0443\u043D\u043A\u0442\u0438 \u043F\u043E\u0440\u044F\u0434\u043A\u0443 \u0434\u0435\u043D\u043D\u043E\u0433\u043E \u0439 \u0440\u043E\u0431\u0456\u0442\u044C \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438.",
    'embedded.confluence.connect-to-confluence.heading': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E Confluence",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};


var $aa8d0c7996b9d139$export$2e2bcd8739ae039 = (0, $46c750dbfcb62780$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $15b8e8af209dce71$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.connect-to-confluence.button': "K\u1EBFt n\u1ED1i Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "N\xfat K\u1EBFt n\u1ED1i Confluence",
    'embedded.confluence.connect-to-confluence.description': "L\u01B0u l\u1EA1i c\xe1c \xfd t\u01B0\u1EDFng, theo d\xf5i c\xe1c m\u1EE5c trong ch\u01B0\u01A1ng tr\xecnh ngh\u1ECB s\u1EF1 v\xe0 ghi ch\xfa chung v\u1EDBi c\u1EA3 \u0111\u1ED9i.",
    'embedded.confluence.connect-to-confluence.heading': "K\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};


var $e5aa7fa4798e6e30$export$2e2bcd8739ae039 = (0, $15b8e8af209dce71$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $cab995b32cecb231$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.connect-to-confluence.button': "\u8FDE\u63A5 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u201C\u8FDE\u63A5 Confluence\u201D\u6309\u94AE",
    'embedded.confluence.connect-to-confluence.description': "\u4EE5\u56E2\u961F\u5F62\u5F0F\u5171\u540C\u4FDD\u5B58\u60F3\u6CD5\u3001\u8DDF\u8E2A\u8BAE\u7A0B\u9879\u76EE\u4EE5\u53CA\u505A\u7B14\u8BB0\u3002",
    'embedded.confluence.connect-to-confluence.heading': "\u8FDE\u63A5\u5230 Confluence",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};


var $f0833e2eb2dc192d$export$2e2bcd8739ae039 = (0, $cab995b32cecb231$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $ef147dc4e43d0e40$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.connect-to-confluence.button': "\u9023\u63A5 Confluence",
    'embedded.confluence.connect-to-confluence.button.aria-label': "\u9023\u63A5 Confluence \u6309\u9215",
    'embedded.confluence.connect-to-confluence.description': "\u4EE5\u5718\u968A\u5F62\u5F0F\u4E00\u8D77\u5132\u5B58\u69CB\u60F3\u3001\u8FFD\u8E64\u8B70\u7A0B\u9805\u76EE\u4EE5\u53CA\u505A\u7B46\u8A18\u3002",
    'embedded.confluence.connect-to-confluence.heading': "\u9023\u7D50\u81F3 Confluence",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};


var $a311485efbb78027$export$2e2bcd8739ae039 = (0, $ef147dc4e43d0e40$export$2e2bcd8739ae039);


const $b4f623f5c9d64129$var$localeToTranslations = {
    'cs-CZ': $773347a5ecc0b550$export$2e2bcd8739ae039,
    'da-DK': $4b444f9ddec14a5d$export$2e2bcd8739ae039,
    'de-DE': $14eaab80d38a0ee6$export$2e2bcd8739ae039,
    'en-US': $865d855a1fa5d471$export$2e2bcd8739ae039,
    'en-GB': $6c55c06d45f02d30$export$2e2bcd8739ae039,
    'en-ZZ': $a9c1813fe7e4af9d$export$2e2bcd8739ae039,
    'es-ES': $e36d3bdbd9bcfbc6$export$2e2bcd8739ae039,
    'fi-FI': $a53fe41909f30ebd$export$2e2bcd8739ae039,
    'fr-FR': $cee97febb9adf70f$export$2e2bcd8739ae039,
    'hu-HU': $4fd5ea0e4e732beb$export$2e2bcd8739ae039,
    'it-IT': $fe343340a045571b$export$2e2bcd8739ae039,
    'ja-JP': $fc6992a6d33f0da5$export$2e2bcd8739ae039,
    'ko-KR': $0433a47f9fb8dcfc$export$2e2bcd8739ae039,
    'no-NO': $746f02eed1044242$export$2e2bcd8739ae039,
    'nl-NL': $a7633fcbda8fb655$export$2e2bcd8739ae039,
    'pl-PL': $44b404dcb1fc48a7$export$2e2bcd8739ae039,
    'pt-BR': $91dadffec46da81e$export$2e2bcd8739ae039,
    'ru-RU': $f2ebe896db83eed6$export$2e2bcd8739ae039,
    'sv-SE': $e47846e1ecea23cd$export$2e2bcd8739ae039,
    'tr-TR': $ed36669dfc29feb4$export$2e2bcd8739ae039,
    'th-TH': $7725b2b070b751bc$export$2e2bcd8739ae039,
    'uk-UA': $aa8d0c7996b9d139$export$2e2bcd8739ae039,
    'vi-VN': $e5aa7fa4798e6e30$export$2e2bcd8739ae039,
    'zh-TW': $a311485efbb78027$export$2e2bcd8739ae039,
    'zh-CN': $f0833e2eb2dc192d$export$2e2bcd8739ae039
};
const $b4f623f5c9d64129$var$fetchTranslations = async (locale)=>$b4f623f5c9d64129$var$localeToTranslations[locale] ?? $865d855a1fa5d471$export$2e2bcd8739ae039;
var $b4f623f5c9d64129$export$2e2bcd8739ae039 = $b4f623f5c9d64129$var$fetchTranslations;
module.exports["default"] = $b4f623f5c9d64129$export$2e2bcd8739ae039;

});

parcelRegister("aI44c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");

/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $7pThu = parcelRequire("7pThu");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $44JTv = parcelRequire("44JTv");


var $1oYQ9 = parcelRequire("1oYQ9");


var $6wQcp = parcelRequire("6wQcp");


var $cGc86 = parcelRequire("cGc86");

const $f3c4af92b1079227$var$embeddedPageContainerSytles = null;
const $f3c4af92b1079227$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4"
        ])
    }, children);
};
const $f3c4af92b1079227$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { height: height } = (0, $44JTv.useContentSize)(uniqueKey);
    (0, $6wQcp.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $42omo.useMemo)(()=>({
            experiences: {
                experience: (0, $7pThu.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $7pThu.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3c4af92b1079227$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%'
                }, children),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1oYQ9.Content), {
        ...props,
        contentType: (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");


var $kudeD = parcelRequire("kudeD");




const $d51843cacb6b0e00$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGc86.UniqueKeyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $elkSx.PageNotFoundEmptyState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f3c4af92b1079227$export$767e3006bdbb424a), props))));
};
module.exports["ViewPage"] = $d51843cacb6b0e00$export$767e3006bdbb424a;

});

parcelRegister("44JTv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4eu1q = parcelRequire("4eu1q");




const $13cd0f2521f3e6f6$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $13cd0f2521f3e6f6$export$4b9c38587bbe6e8b = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $42omo.useState)(1000);
    (0, $42omo.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $13cd0f2521f3e6f6$var$MESSAGE_TYPE && data?.value && // If uniqueKey is provided, check if the message is for the correct uniqueKey; if uniqueKey is undefined, fallback to existing logic to accept all messages
            (uniqueKey ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        visibleHeight: visibleHeight
    };
};


const $e4f5fef5273f9751$var$MESSAGE_TYPE = 'contentSize';
const $e4f5fef5273f9751$export$7e7123f55b1139c9 = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $42omo.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/ const { isMediaOpen: isMediaOpen } = (0, $4eu1q.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $13cd0f2521f3e6f6$export$4b9c38587bbe6e8b)(uniqueKey);
    (0, $42omo.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $e4f5fef5273f9751$var$MESSAGE_TYPE && data?.height && // If uniqueKey is provided, check if the message is for the correct uniqueKey; if uniqueKey is undefined, fallback to existing logic to accept all messages
            (uniqueKey ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};
module.exports["useContentSize"] = $e4f5fef5273f9751$export$7e7123f55b1139c9;

});

parcelRegister("1oYQ9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");







const $9f20096665d70f6d$var$defaultExperienceContextValue = undefined;
const $9f20096665d70f6d$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($9f20096665d70f6d$var$defaultExperienceContextValue);


function $2b815948b6973dc0$export$c90b54e658fc4d7c({ children: children, name: name }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9f20096665d70f6d$export$fb99266658f5da06).Provider, {
        value: name
    }, children);
}


var $jJf3a = parcelRequire("jJf3a");


var $iudHJ = parcelRequire("iudHJ");




var $4HdGj = parcelRequire("4HdGj");

const $b6040bd8c2dd6c87$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $42omo.useRef)();
    const ccExperienceStartedRef = (0, $42omo.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
	 * Start experience as close to the user action as possible.
	 * Our approximation is component's first render.
	 *
	 * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
	 * We need to re-start experience if `contentId` or `spaceKey` has changed.
	 * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
	 */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
				 * We have experience forwarding from confluence-frontend
				 * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
				 */ experience.stopOn(events.find((event)=>(0, $4HdGj.isStop)(event) && event.name === ccExperience && event.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            /**
			 * User can navigates away (EP component unmount) before CC experience started
			 * In this case, we want to abort EP experience as the conclusion.
			 */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};


/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");











var $diaaX = parcelRequire("diaaX");


var $cGc86 = parcelRequire("cGc86");

let $61a21d08c4c4e245$var$host = null;

// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // @atlaskit/simple-xdm/plugin is an ES-module default export, so when loaded via require(), we need to read `.default` (otherwise we get the module namespace object)
    const requiredHost = (parcelRequire("elPZ8"));
    $61a21d08c4c4e245$var$host = requiredHost?.default ?? requiredHost;
}
function $61a21d08c4c4e245$var$defineModule(name, module) {
    $61a21d08c4c4e245$var$host.defineModule(name, module);
}
const $61a21d08c4c4e245$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $42omo.useRef)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $61a21d08c4c4e245$var$defineModule(uniqueKey ? `${0, $diaaX.EXPERIENCE_FORWARDING_MODULE_NAME}_${uniqueKey}` : (0, $diaaX.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $61a21d08c4c4e245$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $42omo.useCallback)(()=>{
        $61a21d08c4c4e245$var$host.dispatch((0, $diaaX.PROPS_UPDATED), {
            addon_key: passThroughProps.uniqueKey ?? (0, $diaaX.CHANNEL_NAME),
            key: passThroughProps.uniqueKey ?? (0, $diaaX.CHANNEL_NAME)
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
		 * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
		 * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
		 **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps),
        passThroughProps.uniqueKey
    ]);
    const dispatchPropsUpdatedRef = (0, $42omo.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $61a21d08c4c4e245$var$defineModule(passThroughProps.uniqueKey ? `${0, $diaaX.PASSTHROUGH_PROPS_MODULE_NAME}_${passThroughProps.uniqueKey}` : (0, $diaaX.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $42omo.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $61a21d08c4c4e245$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $42omo.useRef)();
    const uniqueKey = passThroughProps.uniqueKey ?? (0, $diaaX.CHANNEL_NAME);
    $61a21d08c4c4e245$var$useExperienceForwardingModule();
    $61a21d08c4c4e245$var$usePassThroughPropsModule(passThroughProps);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $61a21d08c4c4e245$var$host.create({
        addon_key: uniqueKey,
        key: uniqueKey,
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}





function $52c6198c4c30a183$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $52c6198c4c30a183$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $52c6198c4c30a183$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($52c6198c4c30a183$var$isSameOrigin(window1.top)) {
            const containerDepth = $52c6198c4c30a183$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$52c6198c4c30a183$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $52c6198c4c30a183$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($52c6198c4c30a183$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $52c6198c4c30a183$export$db5957f3934e2c38() {
    (0, $42omo.useEffect)(()=>{
        $52c6198c4c30a183$var$attachHostOffsetOverride(window);
        return ()=>{
            $52c6198c4c30a183$var$detachHostOffsetOverride();
        };
    }, []);
}



var $kudeD = parcelRequire("kudeD");




const $96c652b8f1100cf8$var$iframeStyles = null;
const $96c652b8f1100cf8$export$5137ec99f248330b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    // `spaceKey` is broadcast via the channel but is not a valid HTML attr.
    const { spaceKey: _spaceKey, ...iframeDomProps } = passThroughProps;
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $42omo.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    (0, $42omo.useEffect)(()=>{
        const handler = (e)=>{
            // only fire onUnload handler if uniqueKey (if it exists) matches
            const uniqueKeyMatch = !uniqueKey || !e.data?.uniqueKey || e.data.uniqueKey === uniqueKey;
            if (e.data.type === 'windowUnload' && uniqueKeyMatch) onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload,
        uniqueKey
    ]);
    (0, $52c6198c4c30a183$export$db5957f3934e2c38)();
    const channel = (0, $61a21d08c4c4e245$export$c745b3af35ea8585)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    }); // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...iframeDomProps,
        className: (0, $gMc0m.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    });
});


/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-anchor */ 






var $inPa6 = parcelRequire("inPa6");


var $lAFHW = parcelRequire("lAFHW");


var $3gadb = parcelRequire("3gadb");


var $4HiV7 = parcelRequire("4HiV7");

const $d46b25c378604447$var$FOOTER_CONTENT_HEIGHT = 52;
const $d46b25c378604447$var$FOOTER_BORDER_PX = 2;
const $d46b25c378604447$export$a2dd5f25b5a4e5d2 = $d46b25c378604447$var$FOOTER_CONTENT_HEIGHT + $d46b25c378604447$var$FOOTER_BORDER_PX;
const $d46b25c378604447$var$containerStyles = null;
const $d46b25c378604447$var$contentWrapperStyles = null;
const $d46b25c378604447$var$logoWrapperSyles = null;
const $d46b25c378604447$var$linkStyles = null;
const $d46b25c378604447$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "footer-container",
        className: (0, $gMc0m.default)([
            "_11c8wadc _16jlidpf _1o9zidpf _i0dl1ex1 _x3do1vhv _4t3i1ex1 _syazazsu _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, url ? /*#__PURE__*/ $42omo.createElement($d46b25c378604447$var$ContentAction, {
        tooltipText: linkTooltip,
        href: url
    }, ({ isHovered: isHovered })=>/*#__PURE__*/ $42omo.createElement($d46b25c378604447$var$Content, {
            isHovered: isHovered,
            label: label
        })) : /*#__PURE__*/ $42omo.createElement($d46b25c378604447$var$Content, {
        label: label
    }));
const $d46b25c378604447$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"
        ])
    }, label, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.ConfluenceLogo), {
        appearance: isHovered ? 'brand' : 'neutral',
        size: "xxsmall"
    })));
const $d46b25c378604447$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $4HiV7.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: tooltipText
    }, /*#__PURE__*/ $42omo.createElement("a", {
        href: href,
        target: "_blank",
        onMouseEnter: ()=>{
            setIsHovered(true);
        },
        onMouseLeave: ()=>{
            setIsHovered(false);
        },
        onFocus: ()=>{
            setIsHovered(true);
        },
        onBlur: ()=>{
            setIsHovered(false);
        },
        onClick: handleClick,
        "data-testid": "link",
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"
        ])
    }, children({
        isHovered: isHovered
    })));
};




/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $7p4As = parcelRequire("7p4As");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");





var $8tdj3 = parcelRequire("8tdj3");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");





var $7pThu = parcelRequire("7pThu");

var $676d88ebebde86c8$exports = {};
$676d88ebebde86c8$exports = new URL("LoginPageIconSVG.f5d1b132.svg", import.meta.url).toString();





const $30be43982da321bc$var$messages = (0, $aXWIB.defineMessages)({
    connectToConfluenceHeading: {
        id: "embedded.confluence.connect-to-confluence.heading",
        defaultMessage: "Connect to Confluence"
    },
    connectToConfluenceDescription: {
        id: "embedded.confluence.connect-to-confluence.description",
        defaultMessage: "Save ideas, track agenda items, and take notes together as a team."
    },
    connectConfluenceButton: {
        id: "embedded.confluence.connect-to-confluence.button",
        defaultMessage: "Connect Confluence"
    },
    connectLoomToConfluenceImageAriaLabel: {
        id: "embedded.confluence.connect-loom-to-confluence.image.aria-label",
        defaultMessage: "Connect Loom to Confluence"
    },
    loginToConfluenceIconAriaLabel: {
        id: "embedded.confluence.login-to-confluence.icon.aria-label",
        defaultMessage: "Login to Confluence"
    },
    connectConfluenceButtonAriaLabel: {
        id: "embedded.confluence.connect-to-confluence.button.aria-label",
        defaultMessage: "Connect Confluence Button"
    },
    buttonLoginToConfluenceNewTab: {
        id: "embedded.confluence.generic-error-page.login-to-confluence-button",
        defaultMessage: "Log in to Confluence"
    },
    paragraphLogin: {
        id: "embedded.confluence.need-to-log-in-paragraph",
        defaultMessage: "You need to be logged in to view this page"
    },
    paragraphAlreadyLoggedIn: {
        id: "embedded.confluence.already-logged-in-paragraph",
        defaultMessage: "Already logged in? Try refreshing."
    },
    paragraphStillHavingTrouble: {
        id: "embedded.confluence.still-having-trouble-paragraph",
        defaultMessage: "Still having trouble? Make sure 3rd party cookies are enabled, or {link}"
    },
    linkTroubleshootingText: {
        id: "embedded.confluence.troubleshooting-link-text",
        defaultMessage: "refer to this troubleshooting guide."
    },
    linkAriaLabel: {
        id: "embedded.confluence.troubleshooting-link.aria-label",
        defaultMessage: "troubleshooting guide link"
    },
    loginAriaLabel: {
        id: "embedded.confluence.login-page.login-button.aria-label",
        defaultMessage: "Login Button"
    },
    loginText: {
        id: "embedded.confluence.login-page.login-text",
        defaultMessage: "You need to be logged in to view this page"
    },
    loginButton: {
        id: "embedded.confluence.login-page.login-button",
        defaultMessage: "Log in to Confluence"
    },
    refreshBanner: {
        id: "embedded.confluence.login-page.refresh-page-banner",
        defaultMessage: "After logging in, this page should refresh automatically. If not, you can click here to refresh"
    },
    refreshBannerLink: {
        id: "embedded.confluence.login-page.refresh-page-banner-refresh-link",
        defaultMessage: "Refresh page"
    }
});
var $30be43982da321bc$export$2e2bcd8739ae039 = $30be43982da321bc$var$messages;





const $b67c8ce1deb4b4b8$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $b67c8ce1deb4b4b8$var$styles = {
    loginButtonWrapper: "_19pkxy5q _otyrpxbi",
    mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
const $b67c8ce1deb4b4b8$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const experience = (0, $42omo.useContext)((0, $9f20096665d70f6d$export$fb99266658f5da06));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $7pThu.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "error-screen-container",
        className: (0, $gMc0m.default)([
            $b67c8ce1deb4b4b8$var$styles.mainWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.250",
        alignInline: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.ConfluenceLogo), {
        size: "large",
        appearance: "brand"
    }), /*#__PURE__*/ $42omo.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($676d88ebebde86c8$exports))),
        alt: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginToConfluenceIconAriaLabel),
        width: "148",
        height: "160"
    }), /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        as: "h2",
        size: "large"
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).paragraphLogin))), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $b67c8ce1deb4b4b8$var$styles.loginButtonWrapper,
        // used instead of className as the className prop is not allowed
        // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
        "data-embedded-confluence-no-global-styles-link-button": "true"
    }, /*#__PURE__*/ $42omo.createElement((0, $7p4As.default), {
        appearance: "primary",
        "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab),
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        href: standaloneConfluenceUrl ?? '',
        target: "_blank"
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab))), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p"
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).paragraphAlreadyLoggedIn)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p"
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).paragraphStillHavingTrouble, {
        link: /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: $b67c8ce1deb4b4b8$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
            target: "_blank",
            "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).linkAriaLabel)
        }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).linkTroubleshootingText))
    }))));
};


/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $fVUfS = parcelRequire("fVUfS");










var $ccHMk = parcelRequire("ccHMk");





var $9HehF = parcelRequire("9HehF");












var $eCEXz = parcelRequire("eCEXz");


var $3sFtD = parcelRequire("3sFtD");

const $6035301bc49c38a6$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCEXz.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #357DE8)",
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $6035301bc49c38a6$export$2e2bcd8739ae039 = $6035301bc49c38a6$var$RefreshBanner;






var $cfdbb61db1eb2e19$exports = {};
$cfdbb61db1eb2e19$exports = new URL("ConnectLoomToConfluenceSVG.8db7b17b.svg", import.meta.url).toString();



var $5dK2X = parcelRequire("5dK2X");

const $6b2be4d3f29fcd62$var$fadeIn = null;
const $6b2be4d3f29fcd62$var$styles = {
    loginButtonWrapper: "_19pkxy5q",
    parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
    refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n",
    loomHeading: "_11c810sd _k48p1pd9 _syazi7uo",
    loomLoginButton: "_2rko1tm3 _11c81d4k _v5642hjt _1bsb842n _4t3i8vuz _bfhk1856 _syaz15cr _k48p1pd9 _o7ks2hjt _irr3hf2y _1di6g6ey"
};
const $6b2be4d3f29fcd62$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $6b2be4d3f29fcd62$export$f14c0e3f98d164c0 = ({ contentId: contentId, parentProduct: parentProduct, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $42omo.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        const uniqueKeyParam = uniqueKey ? `&uniqueKey=${uniqueKey}` : '';
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$6b2be4d3f29fcd62$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}${uniqueKeyParam}`;
    }, [
        url,
        locale,
        uniqueKey
    ]);
    const isLoomParentProduct = parentProduct === 'loom';
    const handleClick = ()=>{
        $6b2be4d3f29fcd62$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $42omo.useState)(false);
    return isLoomParentProduct ? /*#__PURE__*/ $42omo.createElement($6b2be4d3f29fcd62$export$e65dcd3f2d7567ae, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ $42omo.createElement($6b2be4d3f29fcd62$export$50083a1d14fa7d72, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    });
};
const $6b2be4d3f29fcd62$export$e65dcd3f2d7567ae = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "login-page-test-id",
        className: (0, $gMc0m.default)([
            $6b2be4d3f29fcd62$var$styles.parentDiv
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9HehF.ExperienceStart), {
        name: (0, $7pThu.ExperienceNames).LOGIN_PAGE,
        id: `${spaceKey}-${contentId}-loom`
    }), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.400",
        alignInline: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.200",
        alignInline: "center"
    }, /*#__PURE__*/ $42omo.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cfdbb61db1eb2e19$exports))),
        alt: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectLoomToConfluenceImageAriaLabel),
        width: "167",
        height: "110"
    }), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        as: "h2",
        size: "large"
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $6b2be4d3f29fcd62$var$styles.loomHeading
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectToConfluenceHeading))), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        size: "medium"
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectToConfluenceDescription)))), /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: $6b2be4d3f29fcd62$var$styles.loomLoginButton,
        onClick: handleClick,
        testId: "connect-confluence-button",
        "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectConfluenceButtonAriaLabel)
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectConfluenceButton))), displayRefreshBanner && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6b2be4d3f29fcd62$var$styles.refreshBannerFade
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6035301bc49c38a6$export$2e2bcd8739ae039), {
        reloadEP: reloadEP,
        title: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBanner),
        actionLabel: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBannerLink)
    })));
};
const $6b2be4d3f29fcd62$export$50083a1d14fa7d72 = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "login-page-test-id",
        className: (0, $gMc0m.default)([
            $6b2be4d3f29fcd62$var$styles.parentDiv
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9HehF.ExperienceStart), {
        name: (0, $7pThu.ExperienceNames).LOGIN_PAGE,
        id: `${spaceKey}-${contentId}`
    }), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.250",
        alignInline: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.ConfluenceLogo), {
        size: "large",
        appearance: "brand"
    }), /*#__PURE__*/ $42omo.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($676d88ebebde86c8$exports))),
        alt: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginToConfluenceIconAriaLabel),
        width: "148",
        height: "160"
    }), /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        as: "h2",
        size: "large"
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginText))), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $6b2be4d3f29fcd62$var$styles.loginButtonWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        testId: "login-button",
        "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginAriaLabel),
        appearance: "primary",
        onClick: handleClick
    }, formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginButton))), displayRefreshBanner && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6b2be4d3f29fcd62$var$styles.refreshBannerFade
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6035301bc49c38a6$export$2e2bcd8739ae039), {
        reloadEP: reloadEP,
        title: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBanner),
        actionLabel: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBannerLink)
    })));
};
function $6b2be4d3f29fcd62$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}


/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















const $99760c79a6ed56be$var$iframeStyles = null;
const $99760c79a6ed56be$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const iframeRef = (0, $42omo.useRef)(null);
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $42omo.useMemo)(()=>{
        const uniqueKeyParam = uniqueKey ? `&uniqueKey=${uniqueKey}` : '';
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}${uniqueKeyParam}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url,
        uniqueKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HehF.ExperienceStart), {
        name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
        id: `${spaceKey}-${contentId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        "data-testid": "storage-access-page-iframe",
        title: "storage-access-iframe",
        src: src,
        ref: iframeRef,
        className: (0, $gMc0m.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    }));
};



var $3WsBD = parcelRequire("3WsBD");













var $dc5325553138ea46$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $dc5325553138ea46$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $dc5325553138ea46$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $dc5325553138ea46$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $dc5325553138ea46$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
					 */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported.
          So we can skip asking for storage access and direct user to the Login CTA.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $dc5325553138ea46$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $42omo.useReducer)($dc5325553138ea46$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const messageListener = (0, $42omo.useCallback)((messageEvent)=>{
        const { subject: subject, result: result, embeddedConfluenceUrl: embeddedConfluenceUrl } = messageEvent.data ?? {};
        const messageKey = embeddedConfluenceUrl ? new URL(embeddedConfluenceUrl).searchParams.get('uniqueKey') : null;
        if (!subject || !result || messageKey && uniqueKey && messageKey !== uniqueKey) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $7pThu.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $7pThu.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $7pThu.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $7pThu.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker,
        uniqueKey
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};


const $81cee89a8418d895$var$noop = ()=>{};
const $81cee89a8418d895$var$IFRAME_LOAD_TIMEOUT_MS = 2000;
const $81cee89a8418d895$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $3WsBD.useUrl)(props);
    const { state: { contentLoadStarted: contentLoadStarted, iframeLoaded: iframeLoaded } } = (0, $dc5325553138ea46$export$1faa35b5a06780c0)();
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $42omo.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        isLoading: contentLoadStarted && !iframeLoaded || false,
        // if same domain, we bypass loading screen in favor of internal iframe loading experience
        iframeLoaded: iframeLoaded || true,
        // if same domain, set to true so iframe can handle loading experience
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $81cee89a8418d895$var$noop,
        handleContentLoadStarted: $81cee89a8418d895$var$noop,
        handleIframeUnload: $81cee89a8418d895$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($81cee89a8418d895$var$CrossDomainErrorValidation, {
        key: embeddedConfluenceUrl || props.contentId,
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    });
};
const $81cee89a8418d895$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $dc5325553138ea46$export$1faa35b5a06780c0)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $42omo.useRef)(null);
    const iframeOnLoadFiredRef = (0, $42omo.useRef)(false);
    const iframeOnLoadSrcRef = (0, $42omo.useRef)(null);
    const timeoutIdRef = (0, $42omo.useRef)(null);
    const dispatchIframeLoaded = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).IFRAME_LOADED
        });
    }, [
        dispatch
    ]);
    const clearPendingIframeLoadTimeout = (0, $42omo.useCallback)(()=>{
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = null;
        }
    }, []);
    const resetIframeLoadTracking = (0, $42omo.useCallback)(()=>{
        iframeOnLoadFiredRef.current = false;
        iframeOnLoadSrcRef.current = null;
        clearPendingIframeLoadTimeout();
    }, [
        clearPendingIframeLoadTimeout
    ]);
    const handleIframeOnLoad = (0, $42omo.useCallback)(()=>{
        /* Record that the iframe onLoad event has fired and store the current src.
       We verify the iframe src to ensure we only handle the correct iframe,
       as the same Iframe component is also used by the StorageAccessPage component,
       and the src may change during transitions between view/edit modes or other redirects.
    */ if (!iframeRef.current) return;
        iframeOnLoadFiredRef.current = true;
        iframeOnLoadSrcRef.current = iframeRef.current.src;
        // If content has already started loading, dispatch immediately
        if (contentLoadStarted && !iframeLoaded) {
            dispatchIframeLoaded();
            return;
        }
        // If content hasn't started loading yet, set a timeout to dispatch after a delay
        // This handles the case where content fails to load or never sends the start message
        if (!contentLoadStarted && !iframeLoaded) {
            clearPendingIframeLoadTimeout();
            timeoutIdRef.current = setTimeout(()=>{
                // Verify the iframe hasn't changed before dispatching
                if (iframeOnLoadFiredRef.current && iframeRef.current?.src === iframeOnLoadSrcRef.current && !iframeLoaded) dispatchIframeLoaded();
            }, $81cee89a8418d895$var$IFRAME_LOAD_TIMEOUT_MS);
        }
    }, [
        contentLoadStarted,
        iframeLoaded,
        dispatchIframeLoaded,
        clearPendingIframeLoadTimeout
    ]);
    // As soon as both the iframe onLoad has fired AND content has started loading, dispatch the IFRAME_LOADED action.
    (0, $42omo.useEffect)(()=>{
        if (iframeOnLoadFiredRef.current && contentLoadStarted && iframeRef.current?.src === iframeOnLoadSrcRef.current && !iframeLoaded) {
            clearPendingIframeLoadTimeout();
            dispatchIframeLoaded();
        }
    }, [
        clearPendingIframeLoadTimeout,
        contentLoadStarted,
        dispatchIframeLoaded,
        iframeLoaded
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!contentLoadStarted && !iframeLoaded) resetIframeLoadTracking();
    }, [
        contentLoadStarted,
        iframeLoaded,
        resetIframeLoadTracking
    ]);
    (0, $42omo.useEffect)(()=>()=>{
            clearPendingIframeLoadTimeout();
        }, [
        clearPendingIframeLoadTimeout
    ]);
    const handleContentLoadStarted = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    const isLoginFlowDisabled = (0, $42omo.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $42omo.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
     If anonymous access is permitted globally but restricted on a content's parent space,
     the iframe will attempt a login redirect which we intercept.
     To avoid an error in the iframe, we need to wait for the iframe window to unload
     before unmouting the Iframe component.
   */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $42omo.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
                        status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        isLoading: contentLoadStarted && !iframeLoaded,
        iframeLoaded: iframeLoaded,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99760c79a6ed56be$export$64a8a56a2c35628c), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b2be4d3f29fcd62$export$f14c0e3f98d164c0), {
            contentId: contentId,
            parentProduct: parentProduct,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b67c8ce1deb4b4b8$export$42f84e610f279c31), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};


var $44JTv = parcelRequire("44JTv");







var $jNfGN = parcelRequire("jNfGN");

const $9092c699d4343515$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $42omo.useState)(standaloneConfluenceUrl);
    (0, $42omo.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $7pThu.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
	 * Currently footer is hidden for the JSM Portal view which passes
	 * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
	 *
	 * JSM portal view will provide "JSM-Portal" as the parent product eventually
	 * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
	 * We need to support these two parent product keys to keep backward compatible for the time being.
	 *
	 * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
	 *
	 * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
	 * External API remains unchanged.
	 */ const showFooter = (0, $42omo.useMemo)(()=>{
        const parentProducts = [
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};





var $dsm7I = parcelRequire("dsm7I");

//Default parent scroll offset (in pixels) used by fallback window scrolling ; this offset keeps content visible below sticky headers
const $d78300ed00789946$var$PARENT_SCROLL_OFFSET_PX = 80;
const $d78300ed00789946$export$8c87e334b260af87 = (isHeightSetFromContent, uniqueKey, customScrollHandler)=>{
    const iframeBySourceRef = (0, $42omo.useRef)(new WeakMap());
    const customScrollHandlerRef = (0, $42omo.useRef)(customScrollHandler);
    (0, $42omo.useEffect)(()=>{
        customScrollHandlerRef.current = customScrollHandler;
    }, [
        customScrollHandler
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isHeightSetFromContent) return undefined;
        const handler = (event)=>{
            if (event.data?.type !== (0, $dsm7I.SCROLL_TO_HASH_MESSAGE_TYPE)) return;
            // Only accept messages sent by the same embed instance
            if (uniqueKey && event.data?.uniqueKey !== uniqueKey) return;
            const offsetTop = event.data?.offsetTop;
            if (typeof offsetTop !== 'number') return;
            const source = event.source;
            if (!source || typeof source !== 'object') return;
            let iframe = iframeBySourceRef.current.get(source);
            if (!iframe) {
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                iframe = Array.from(document.querySelectorAll('iframe')).find((f)=>f.contentWindow === source);
                if (iframe) iframeBySourceRef.current.set(source, iframe);
            }
            if (!iframe) return;
            // Use custom handler if provided, otherwise fall back to default scroll
            if (customScrollHandlerRef.current) customScrollHandlerRef.current(iframe, offsetTop);
            else {
                const iframeRect = iframe.getBoundingClientRect();
                const scrollTarget = iframeRect.top + window.scrollY + offsetTop - $d78300ed00789946$var$PARENT_SCROLL_OFFSET_PX;
                window.scrollTo({
                    top: Math.max(0, scrollTarget),
                    behavior: 'smooth'
                });
            }
        };
        window.addEventListener('message', handler);
        return ()=>window.removeEventListener('message', handler);
    }, [
        isHeightSetFromContent,
        uniqueKey
    ]);
};








var $elkSx = parcelRequire("elkSx");




const $f56ea57bc2c8b179$var$messages = (0, $aXWIB.defineMessages)({
    viewInConfluence: {
        id: "embedded.confluence.footer.hover.text",
        defaultMessage: "View in Confluence"
    },
    poweredBy: {
        id: "embedded.confluence.footer.prefix",
        defaultMessage: "Powered by"
    }
});
var $f56ea57bc2c8b179$export$2e2bcd8739ae039 = $f56ea57bc2c8b179$var$messages;





/* IframeLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $d8SNb = parcelRequire("d8SNb");


var $kpYGL = parcelRequire("kpYGL");

const $60b4b6eb3073ac4f$var$visibilityStyles = {
    hidden: "_1e0cglyw",
    invisible: "_tzy4idpf _4t3i1osq",
    visible: "_tzy4kb7n _4t3i1osq"
};
const $60b4b6eb3073ac4f$var$overlayStyles = {
    default: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _1bahv2br _1pbyb4wl"
};
const $60b4b6eb3073ac4f$var$containerStyles = {
    default: "_kqswh2mm _1bsb1osq _4t3i1osq"
};
const $60b4b6eb3073ac4f$export$666e684aed003bfe = ({ children: children, iframeLoaded: iframeLoaded, isLoading: isLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $60b4b6eb3073ac4f$var$containerStyles.default,
        "aria-busy": isLoading,
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        gap: "space.400",
        alignItems: "start",
        xcss: isLoading ? $60b4b6eb3073ac4f$var$overlayStyles.default : $60b4b6eb3073ac4f$var$visibilityStyles.hidden,
        "aria-hidden": !isLoading,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "250px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "40px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.0",
        "aria-hidden": isLoading,
        xcss: !iframeLoaded ? $60b4b6eb3073ac4f$var$visibilityStyles.invisible : $60b4b6eb3073ac4f$var$visibilityStyles.visible
    }, children));


const $2b9005daf957887f$var$IframeWrapper = ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, wrapper?.(children) ?? children);
// helper to merge iframe refs
function $2b9005daf957887f$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $2b9005daf957887f$export$7c6e2c02157bb7d2 = (props)=>{
    const { contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: _navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, embeddedConfluenceSource: embeddedConfluenceSource, queryParams: _queryParams, spaceKey: spaceKey, ...rest } = props;
    // Broadcast `spaceKey` so the iframe header prefers the parent prop over
    // the URL path, which can carry a stale space alias after a rename (JPNS-115645).
    const passThroughProps = (0, $c6GJD.default).getExperimentValue('embedded_confluence_send_space_key_to_iframe', 'isEnabled', false) ? {
        ...rest,
        spaceKey: spaceKey
    } : rest;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const experienceTracker = (0, $iudHJ.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $b6040bd8c2dd6c87$export$48d5d434479c259e)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $3WsBD.useUrl)(props);
    /**
   * The difference between hasFooter and hasFooterLogo can be found here
   * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
   *
   * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
   */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $9092c699d4343515$export$d07da6ac6fc160b0)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $44JTv.useContentSize)(uniqueKey);
    (0, $d78300ed00789946$export$8c87e334b260af87)(passThroughProps.isHeightSetFromContent, uniqueKey, passThroughProps.scrollToHashHandler);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJf3a.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2b815948b6973dc0$export$c90b54e658fc4d7c), {
        name: experience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $81cee89a8418d895$export$3b0759108d92fe77), props, ({ iframeRef: iframeRef, iframeLoaded: iframeLoaded, isLoading: isLoading, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2b9005daf957887f$var$IframeWrapper, {
            wrapper: contentConfiguration.getWrapperElement
        }, embeddedConfluenceUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60b4b6eb3073ac4f$export$666e684aed003bfe), {
            iframeLoaded: iframeLoaded,
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $96c652b8f1100cf8$export$5137ec99f248330b), {
            ref: $2b9005daf957887f$var$mergeIframeRefs(iframeRef, externalIframeRef),
            // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
            src: redirectedToLogin ? '' : embeddedConfluenceUrl,
            ...passThroughProps,
            navigationPolicy: navigationPolicy,
            style: {
                flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
            },
            uniqueKey: uniqueKey,
            onLoad: (e)=>{
                handleIframeOnLoad();
                onLoad?.(e);
            },
            onUnload: handleIframeUnload,
            onContentLoadStarted: handleContentLoadStarted
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $elkSx.PageNotFoundEmptyState), {
            embeddedConfluenceSource: embeddedConfluenceSource
        })), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d46b25c378604447$export$a06f1c675e846f6f), {
            url: footerUrl,
            linkTooltip: formatMessage((0, $f56ea57bc2c8b179$export$2e2bcd8739ae039).viewInConfluence),
            label: formatMessage((0, $f56ea57bc2c8b179$export$2e2bcd8739ae039).poweredBy)
        })))));
};
module.exports["Content"] = $2b9005daf957887f$export$7c6e2c02157bb7d2;

});

parcelRegister("4HdGj", function(module, exports) {
const $e8b7e85943c161a1$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $e8b7e85943c161a1$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
module.exports["isStop"] = $e8b7e85943c161a1$export$16e3f1b03b231b35;
module.exports["hasName"] = $e8b7e85943c161a1$export$57069f5b2ecc9128;

});

parcelRegister("elPZ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// @ts-nocheck
// @ts-nocheck

var $hI6hf = parcelRequire("hI6hf");

// @ts-nocheck
const $dc8ae5c08775b1ec$var$allowedPlatformFeatureFlags = [];
function $dc8ae5c08775b1ec$export$bd17c6970f4d989e() {
    const flags = {};
    if (window.connectHost && window.connectHost.getBooleanFeatureFlag) $dc8ae5c08775b1ec$var$allowedPlatformFeatureFlags.forEach((key)=>flags[key] = window.connectHost.getBooleanFeatureFlag(key));
    return flags;
}


// @ts-nocheck
/**
 * Postmessage format:
 *
 * Initialization
 * --------------
 * {
 *   type: 'init',
 *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
 * }
 *
 * Request
 * -------
 * {
 *   type: 'req',
 *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
 *   mid: 'xyz',  // a unique message identifier, required for callbacks
 *   mod: 'cookie',  // the module name
 *   fn: 'read',  // the method name
 *   args: [arguments]  // the method arguments
 * }
 *
 * Response
 * --------
 * {
 *   type: 'resp'
 *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
 *   mid: 'xyz',  // a unique message identifier, obtained from the request
 *   args: [arguments]  // the callback arguments
 * }
 *
 * Event
 * -----
 * {
 *   type: 'evt',
 *   etyp: 'some-event',
 *   evnt: { ... }  // the event data
 *   mid: 'xyz', // a unique message identifier for the event
 * }
 **/ 
var $fffmw = parcelRequire("fffmw");




let $6c450c4405c18a50$var$VALID_EVENT_TIME_MS = 30000; //30 seconds
class $6c450c4405c18a50$var$XDMRPC extends (0, $fffmw.default) {
    _padUndefinedArguments(array, length) {
        return array.length >= length ? array : array.concat(new Array(length - array.length));
    }
    _verifyAPI(event, reg) {
        var untrustedTargets = event.data.targets;
        if (!untrustedTargets) return;
        var trustedSpec = this.getApiSpec();
        var tampered = false;
        function check(trusted, untrusted) {
            Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                if (typeof untrusted[name] === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
            });
        }
        check(trustedSpec, untrustedTargets);
        if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
        event.source.postMessage({
            type: 'api_tamper',
            tampered: tampered
        }, reg.extension.url);
        else // eslint-disable-next-line no-console
        console.warn('_verifyAPI postMessage skipped as event source missing.');
    }
    _handleInit(event, reg) {
        if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
        event.source.postMessage({
            type: 'init_received'
        }, reg.extension.url);
        else // eslint-disable-next-line no-console
        console.warn('_handleInit postMessage skipped as event source missing.');
        this._registeredExtensions[reg.extension_id].source = event.source;
        if (reg.initCallback) {
            reg.initCallback(event.data.eid);
            delete reg.initCallback;
        }
        if (event.data.targets) this._verifyAPI(event, reg);
    }
    _getHostOffset(event, _window) {
        var hostWindow = event.source;
        var hostFrameOffset = null;
        var windowReference = _window || window; // For testing
        if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
        if (typeof hostFrameOffset !== 'number') {
            hostFrameOffset = 0;
            // Find the closest frame that has the same origin as event source
            while(!this._hasSameOrigin(hostWindow)){
                // Climb up the iframe tree 1 layer
                hostFrameOffset++;
                hostWindow = hostWindow.parent;
            }
        }
        if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
        event.source.postMessage({
            hostFrameOffset: hostFrameOffset
        }, event.origin);
        else // eslint-disable-next-line no-console
        console.warn('_getHostOffset postMessage skipped as event source missing.');
    }
    _hasSameOrigin(window1) {
        if (window1 === window1.top) return true;
        try {
            // Try set & read a variable on the given window
            // If we can successfully read the value then it means the given window has the same origin
            // as the window that is currently executing the script
            var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
            window1[testVariableName] = true;
            return window1[testVariableName];
        } catch (e) {
        // A exception will be thrown if the windows doesn't have the same origin
        }
        return false;
    }
    _handleResponse(event) {
        var data = event.data;
        var pendingCallback = this._pendingCallbacks[data.mid];
        if (pendingCallback) {
            delete this._pendingCallbacks[data.mid];
            pendingCallback.apply(window, data.args);
        }
    }
    registerRequestNotifier(cb) {
        this._registeredRequestNotifier = cb;
    }
    _handleRequest(event, reg) {
        function sendResponse() {
            var args = (0, $hI6hf.default).sanitizeStructuredClone((0, $hI6hf.default).argumentsToArray(arguments));
            if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
            event.source.postMessage({
                mid: event.data.mid,
                type: 'resp',
                forPlugin: true,
                args: args
            }, reg.extension.url);
            else // eslint-disable-next-line no-console
            console.warn('_handleRequest postMessage skipped as event source missing.');
        }
        var data = event.data;
        var module = this._registeredAPIModules[data.mod];
        const extension = this.getRegisteredExtensions(reg.extension)[0];
        if (module) {
            let fnName = data.fn;
            if (data._cls) {
                const Cls = module[data._cls];
                const ns = data.mod + '-' + data._cls + '-';
                sendResponse._id = data._id;
                if (fnName === 'constructor') {
                    if (!Cls._construct) {
                        Cls.constructor.prototype._destroy = function() {
                            delete this._context._proxies[ns + this._id];
                        };
                        Cls._construct = function(...args) {
                            const inst = new Cls.constructor(...args);
                            const callback = args[args.length - 1];
                            inst._id = callback._id;
                            inst._context = callback._context;
                            inst._context._proxies[ns + inst._id] = inst;
                            return inst;
                        };
                    }
                    module = Cls;
                    fnName = '_construct';
                } else module = extension._proxies[ns + data._id];
            }
            let method = module[fnName];
            if (method) {
                var methodArgs = data.args;
                var padLength = method.length - 1;
                if (fnName === '_construct') padLength = module.constructor.length - 1;
                sendResponse._context = extension;
                methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                methodArgs.push(sendResponse);
                const promiseResult = method.apply(module, methodArgs);
                if (method.returnsPromise) {
                    if (!(typeof promiseResult === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                    else promiseResult.then((result)=>{
                        sendResponse(undefined, result);
                    }).catch((err)=>{
                        err = err instanceof Error ? err.message : err;
                        sendResponse(err);
                    });
                }
                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                    module: data.mod,
                    fn: data.fn,
                    type: data.type,
                    args: methodArgs,
                    addon_key: reg.extension.addon_key,
                    key: reg.extension.key,
                    extension_id: reg.extension_id
                });
            }
        }
    }
    _handleBroadcast(event, reg) {
        var event_data = event.data;
        var targetSpec = (r)=>r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
        this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
    }
    _handleKeyTriggered(event, reg) {
        var eventData = event.data;
        var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
        var listeners = this._keycodeCallbacks[keycodeEntry];
        if (listeners) listeners.forEach((listener)=>{
            listener.call(null, {
                addon_key: reg.extension.addon_key,
                key: reg.extension.key,
                extension_id: reg.extension_id,
                keycode: eventData.keycode,
                modifiers: eventData.modifiers
            });
        }, this);
    }
    defineAPIModule(module, moduleName) {
        moduleName = moduleName || '_globals';
        this._registeredAPIModules[moduleName] = (0, $hI6hf.default).extend({}, this._registeredAPIModules[moduleName] || {}, module);
        return this._registeredAPIModules;
    }
    isAPIModuleDefined(moduleName) {
        return typeof this._registeredAPIModules[moduleName] !== 'undefined';
    }
    _pendingEventKey(targetSpec, time) {
        var key = targetSpec.addon_key || 'global';
        if (targetSpec.key) key = `${key}@@${targetSpec.key}`;
        key = `${key}@@${time}`;
        return key;
    }
    queueEvent(type, targetSpec, event, callback) {
        var loaded_frame, targets = this._findRegistrations(targetSpec);
        loaded_frame = targets.some((target)=>{
            return target.registered_events !== undefined;
        }, this);
        if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
        else {
            this._cleanupInvalidEvents();
            var time = new Date().getTime();
            this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                type: type,
                targetSpec: targetSpec,
                event: event,
                callback: callback,
                time: time,
                uid: (0, $hI6hf.default).randomString()
            };
        }
    }
    _cleanupInvalidEvents() {
        let now = new Date().getTime();
        let keys = Object.keys(this._pendingEvents);
        keys.forEach((index)=>{
            let element = this._pendingEvents[index];
            let eventIsValid = now - element.time <= $6c450c4405c18a50$var$VALID_EVENT_TIME_MS;
            if (!eventIsValid) delete this._pendingEvents[index];
        });
    }
    _handleEventQuery(message, extension) {
        let executed = {};
        let now = new Date().getTime();
        let keys = Object.keys(this._pendingEvents);
        keys.forEach((index)=>{
            let element = this._pendingEvents[index];
            let eventIsValid = now - element.time <= $6c450c4405c18a50$var$VALID_EVENT_TIME_MS;
            let isSameTarget = !element.targetSpec || this._findRegistrations(element.targetSpec).length !== 0;
            if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
            if (eventIsValid && isSameTarget) {
                executed[index] = element;
                element.targetSpec = element.targetSpec || {};
                this.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
            } else if (!eventIsValid) delete this._pendingEvents[index];
        });
        this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
        return executed;
    }
    _handleUnload(event, reg) {
        if (!reg) return;
        if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
        if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
    }
    dispatch(type, targetSpec, event, callback, source) {
        function sendEvent(reg, evnt) {
            if (reg.source && reg.source.postMessage) {
                var mid;
                if (callback) {
                    mid = (0, $hI6hf.default).randomString();
                    this._pendingCallbacks[mid] = callback;
                }
                reg.source.postMessage({
                    type: 'evt',
                    mid: mid,
                    etyp: type,
                    evnt: evnt
                }, reg.extension.url);
            }
        }
        var registrations = this._findRegistrations(targetSpec || {});
        registrations.forEach(function(reg) {
            if (source && !reg.source) reg.source = source;
            if (reg.source) (0, $hI6hf.default)._bind(this, sendEvent)(reg, event);
        }, this);
    }
    _findRegistrations(targetSpec) {
        if (this._registeredExtensions.length === 0) {
            (0, $hI6hf.default).error('no registered extensions', this._registeredExtensions);
            return [];
        }
        var keys = Object.getOwnPropertyNames(targetSpec);
        var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map((key)=>{
            return this._registeredExtensions[key];
        });
        if (targetSpec instanceof Function) return registrations.filter(targetSpec);
        else return registrations.filter(function(reg) {
            return keys.every(function(key) {
                return reg.extension[key] === targetSpec[key];
            });
        });
    }
    registerExtension(extension_id, data) {
        data._proxies = {};
        data.extension_id = extension_id;
        this._registeredExtensions[extension_id] = data;
    }
    _keycodeKey(key, modifiers, extension_id) {
        var code = key;
        if (modifiers) {
            if (typeof modifiers === 'string') modifiers = [
                modifiers
            ];
            modifiers.sort();
            modifiers.forEach((modifier)=>{
                code += '$$' + modifier;
            }, this);
        }
        return code + '__' + extension_id;
    }
    registerKeyListener(extension_id, key, modifiers, callback) {
        if (typeof modifiers === 'string') modifiers = [
            modifiers
        ];
        var reg = this._registeredExtensions[extension_id];
        var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
        if (!this._keycodeCallbacks[keycodeEntry]) {
            this._keycodeCallbacks[keycodeEntry] = [];
            reg.source.postMessage({
                type: 'key_listen',
                keycode: key,
                modifiers: modifiers,
                action: 'add'
            }, reg.extension.url);
        }
        this._keycodeCallbacks[keycodeEntry].push(callback);
    }
    unregisterKeyListener(extension_id, key, modifiers, callback) {
        var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
        var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
        var reg = this._registeredExtensions[extension_id];
        if (potentialCallbacks) {
            if (callback) {
                var index = potentialCallbacks.indexOf(callback);
                this._keycodeCallbacks[keycodeEntry].splice(index, 1);
            } else delete this._keycodeCallbacks[keycodeEntry];
            if (reg.source && reg.source.postMessage) reg.source.postMessage({
                type: 'key_listen',
                keycode: key,
                modifiers: modifiers,
                action: 'remove'
            }, reg.extension.url);
        }
    }
    registerClickHandler(callback) {
        if (typeof callback !== 'function') throw new Error('callback must be a function');
        this._clickHandlers.push(callback);
    }
    _handleAddonClick(event, reg) {
        for(var i = 0; i < this._clickHandlers.length; i++)if (typeof this._clickHandlers[i] === 'function') this._clickHandlers[i]({
            addon_key: reg.extension.addon_key,
            key: reg.extension.key,
            extension_id: reg.extension_id
        });
    }
    unregisterClickHandler() {
        this._clickHandlers = [];
    }
    getApiSpec(addonKey) {
        function getModuleDefinition(mod) {
            return Object.getOwnPropertyNames(mod).reduce((accumulator, memberName)=>{
                const member = mod[memberName];
                switch(typeof member){
                    case 'function':
                        accumulator[memberName] = {
                            args: (0, $hI6hf.default).argumentNames(member),
                            returnsPromise: member.returnsPromise || false
                        };
                        break;
                    case 'object':
                        if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                        break;
                }
                return accumulator;
            }, {});
        }
        return Object.getOwnPropertyNames(this._registeredAPIModules).reduce((accumulator, moduleName)=>{
            var module = this._registeredAPIModules[moduleName];
            if (typeof module.addonKey === 'undefined' || module.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module);
            return accumulator;
        }, {});
    }
    _originEqual(url, origin) {
        function strCheck(str) {
            return typeof str === 'string' && str.length > 0;
        }
        let urlOrigin = (0, $hI6hf.default).getOrigin(url);
        // check strings are strings and they contain something
        if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
        return origin === urlOrigin;
    }
    // validate origin of postMessage
    _checkOrigin(event, reg) {
        let no_source_types = [
            'init'
        ];
        let isNoSourceType = reg && no_source_types.includes(event.data.type);
        let sourceTypeMatches = reg && event.source === reg.source;
        let hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
        let isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
        // get_host_offset fires before init
        if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
        // check undefined for chromium (Issue 395010)
        if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
        return isValidOrigin;
    }
    getRegisteredExtensions(filter) {
        if (filter) return this._findRegistrations(filter);
        return this._registeredExtensions;
    }
    unregisterExtension(filter) {
        let registrations = this._findRegistrations(filter);
        if (registrations.length !== 0) registrations.forEach(function(registration) {
            let keys = Object.keys(this._pendingEvents);
            keys.forEach((index)=>{
                let element = this._pendingEvents[index];
                let targetSpec = element.targetSpec || {};
                if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete this._pendingEvents[index];
            });
            delete this._registeredExtensions[registration.extension_id];
        }, this);
    }
    setFeatureFlagGetter(getBooleanFeatureFlag) {
        this._getBooleanFeatureFlag = getBooleanFeatureFlag;
    }
    constructor(config){
        config = config || {};
        super(config);
        this._registeredExtensions = config.extensions || {};
        this._registeredAPIModules = {};
        this._registeredAPIModules._globals = {};
        this._pendingCallbacks = {};
        this._keycodeCallbacks = {};
        this._clickHandlers = [];
        this._pendingEvents = {};
        this._messageHandlers = {
            init: this._handleInit,
            req: this._handleRequest,
            resp: this._handleResponse,
            broadcast: this._handleBroadcast,
            event_query: this._handleEventQuery,
            key_triggered: this._handleKeyTriggered,
            addon_clicked: this._handleAddonClick,
            get_host_offset: this._getHostOffset,
            unload: this._handleUnload
        };
    }
}
var $6c450c4405c18a50$export$2e2bcd8739ae039 = $6c450c4405c18a50$var$XDMRPC;


class $98c689279858d84f$var$Connect {
    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ dispatch(type, targetSpec, event, callback) {
        this._xdm.queueEvent(type, targetSpec, event, callback);
        return this.getExtensions(targetSpec);
    }
    /**
   * Send a message to iframes matching the targetSpec immediately. This message will
   *  only be sent to iframes that are already open, and will not be delivered if none
   *  are currently open.
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   */ broadcast(type, targetSpec, event) {
        this._xdm.dispatch(type, targetSpec, event, null, null);
        return this.getExtensions(targetSpec);
    }
    _createId(extension) {
        if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
        return extension.addon_key + '__' + extension.key + '__' + (0, $hI6hf.default).randomString();
    }
    /**
   * Creates a new iframed module, without actually creating the DOM element.
   * The iframe attributes are passed to the 'setupCallback', which is responsible for creating
   * the DOM element and returning the window reference.
   *
   * @param extension The extension definition. Example:
   *   {
   *     addon_key: 'my-addon',
   *     key: 'my-module',
   *     url: 'https://example.com/my-module',
   *     options: {
   *         autoresize: false,
   *         hostOrigin: 'https://connect-host.example.com/'
   *     }
   *   }
   *
   * @param initCallback The optional initCallback is called when the bridge between host and iframe is established.
   **/ create(extension, initCallback, unloadCallback) {
        let extension_id = this.registerExtension(extension, initCallback, unloadCallback);
        let options = extension.options || {};
        options.platformFeatureFlags = (0, $dc8ae5c08775b1ec$export$bd17c6970f4d989e)();
        let data = {
            extension_id: extension_id,
            api: this._xdm.getApiSpec(extension.addon_key),
            origin: (0, $hI6hf.default).locationOrigin(),
            options: options
        };
        return {
            id: extension_id,
            name: JSON.stringify(data),
            src: extension.url
        };
    }
    // This is called from ACJS
    // noinspection JSUnusedGlobalSymbols
    registerRequestNotifier(callback) {
        this._xdm.registerRequestNotifier(callback);
    }
    registerExtension(extension, initCallback, unloadCallback) {
        let extension_id = this._createId(extension);
        this._xdm.registerExtension(extension_id, {
            extension: extension,
            initCallback: initCallback,
            unloadCallback: unloadCallback
        });
        return extension_id;
    }
    registerKeyListener(extension_id, key, modifiers, callback) {
        this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
    }
    unregisterKeyListener(extension_id, key, modifiers, callback) {
        this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
    }
    registerClickHandler(callback) {
        this._xdm.registerClickHandler(callback);
    }
    unregisterClickHandler() {
        this._xdm.unregisterClickHandler();
    }
    defineModule(moduleName, module, options) {
        this._xdm.defineAPIModule(module, moduleName, options);
    }
    isModuleDefined(moduleName) {
        return this._xdm.isAPIModuleDefined(moduleName);
    }
    defineGlobals(module) {
        this._xdm.defineAPIModule(module);
    }
    getExtensions(filter) {
        return this._xdm.getRegisteredExtensions(filter);
    }
    unregisterExtension(filter) {
        return this._xdm.unregisterExtension(filter);
    }
    returnsPromise(wrappedMethod) {
        wrappedMethod.returnsPromise = true;
    }
    setFeatureFlagGetter(getBooleanFeatureFlag) {
        this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
    }
    registerExistingExtension(extension_id, data) {
        return this._xdm.registerExtension(extension_id, data);
    }
    constructor(){
        this._xdm = new (0, $6c450c4405c18a50$export$2e2bcd8739ae039)();
    }
}
var $98c689279858d84f$export$2e2bcd8739ae039 = $98c689279858d84f$var$Connect;


const $1286b3722989d241$var$_default_1 = new (0, $98c689279858d84f$export$2e2bcd8739ae039)();
var $1286b3722989d241$export$2e2bcd8739ae039 = $1286b3722989d241$var$_default_1;
module.exports["default"] = $1286b3722989d241$export$2e2bcd8739ae039;

});

parcelRegister("hI6hf", function(module, exports) {
// @ts-nocheck
const $1972964b8dcb3206$var$LOG_PREFIX = '[Simple-XDM] ';
const $1972964b8dcb3206$var$nativeBind = Function.prototype.bind;
const $1972964b8dcb3206$var$util = {
    locationOrigin () {
        if (!window.location.origin) return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        else return window.location.origin;
    },
    randomString () {
        return Math.floor(Math.random() * 1000000000).toString(16);
    },
    isString (str) {
        return typeof str === 'string' || str instanceof String;
    },
    argumentsToArray (arrayLike) {
        return Array.prototype.slice.call(arrayLike);
    },
    argumentNames (fn) {
        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/gm, '') // strip comments
        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
        .match(/([^\s,]+)/g) || [];
    },
    hasCallback (args) {
        var length = args.length;
        return length > 0 && typeof args[length - 1] === 'function';
    },
    error (msg) {
        if (window.console && window.console.error) {
            var outputError = [];
            if (typeof msg === 'string') {
                outputError.push($1972964b8dcb3206$var$LOG_PREFIX + msg);
                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
            } else {
                outputError.push($1972964b8dcb3206$var$LOG_PREFIX);
                outputError = outputError.concat(Array.prototype.slice.call(arguments));
            }
            window.console.error.apply(null, outputError);
        }
    },
    warn (msg) {
        if (window.console) // eslint-disable-next-line no-console
        console.warn($1972964b8dcb3206$var$LOG_PREFIX + msg);
    },
    log (msg) {
        if (window.console) window.console.log($1972964b8dcb3206$var$LOG_PREFIX + msg);
    },
    _bind (thisp, fn) {
        if ($1972964b8dcb3206$var$nativeBind && fn.bind === $1972964b8dcb3206$var$nativeBind) return fn.bind(thisp);
        return function() {
            return fn.apply(thisp, arguments);
        };
    },
    throttle (func, wait, context) {
        var previous = 0;
        return function() {
            var now = Date.now();
            if (now - previous > wait) {
                previous = now;
                func.apply(context, arguments);
            }
        };
    },
    each (list, iteratee) {
        var length;
        var key;
        if (list) {
            length = list.length;
            if (length != null && typeof list !== 'function') {
                key = 0;
                while(key < length){
                    if (iteratee.call(list[key], key, list[key]) === false) break;
                    key += 1;
                }
            } else {
                for(key in list)if (list.hasOwnProperty(key)) {
                    if (iteratee.call(list[key], key, list[key]) === false) break;
                }
            }
        }
    },
    extend (dest) {
        var args = arguments;
        var srcs = [].slice.call(args, 1, args.length);
        srcs.forEach(function(source) {
            if (typeof source === 'object') Object.getOwnPropertyNames(source).forEach(function(name) {
                dest[name] = source[name];
            });
        });
        return dest;
    },
    sanitizeStructuredClone (object) {
        const whiteList = [
            Boolean,
            String,
            Date,
            RegExp,
            Blob,
            File,
            FileList,
            ArrayBuffer
        ];
        const blackList = [
            Error,
            Node
        ];
        const warn = $1972964b8dcb3206$var$util.warn;
        var visitedObjects = [];
        function _clone(value) {
            if (typeof value === 'function') {
                warn('A function was detected and removed from the message.');
                return null;
            }
            if (blackList.some((t)=>{
                if (value instanceof t) {
                    warn(`${t.name} object was detected and removed from the message.`);
                    return true;
                }
                return false;
            })) return {};
            if (value && typeof value === 'object' && whiteList.every((t)=>!(value instanceof t))) {
                let newValue;
                if (Array.isArray(value)) newValue = value.map(function(element) {
                    return _clone(element);
                });
                else {
                    if (visitedObjects.indexOf(value) > -1) {
                        warn('A circular reference was detected and removed from the message.');
                        return null;
                    }
                    visitedObjects.push(value);
                    newValue = {};
                    for(let name in value)if (value.hasOwnProperty(name)) {
                        let clonedValue = _clone(value[name]);
                        if (clonedValue !== null) newValue[name] = clonedValue;
                    }
                    visitedObjects.pop();
                }
                return newValue;
            }
            return value;
        }
        return _clone(object);
    },
    getOrigin (url, base) {
        // everything except IE11
        if (typeof URL === 'function') try {
            return new URL(url, base).origin;
        } catch (e) {}
        // ie11 + safari 10
        var doc = document.implementation.createHTMLDocument('');
        if (base) {
            var baseElement = doc.createElement('base');
            baseElement.href = base;
            doc.head.appendChild(baseElement);
        }
        var anchorElement = doc.createElement('a');
        anchorElement.href = url;
        doc.body.appendChild(anchorElement);
        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
        //ie11, only include port if referenced in initial URL
        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
        return origin;
    }
};
var $1972964b8dcb3206$export$2e2bcd8739ae039 = $1972964b8dcb3206$var$util;
module.exports["default"] = $1972964b8dcb3206$export$2e2bcd8739ae039;

});

parcelRegister("fffmw", function(module, exports) {
// @ts-nocheck

var $hI6hf = parcelRequire("hI6hf");

class $80e5cf8f12c63ab1$var$PostMessage {
    _registerListener(listenOn) {
        if (!listenOn || !listenOn.addEventListener) listenOn = window;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenOn.addEventListener('message', (0, $hI6hf.default)._bind(this, this._receiveMessage), false);
    }
    _receiveMessage(event) {
        let handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
        if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
        if (!handler || !this._checkOrigin(event, reg)) return false;
        handler.call(this, event, reg);
    }
    constructor(data){
        let d = data || {};
        this._registerListener(d.listenOn);
    }
}
var $80e5cf8f12c63ab1$export$2e2bcd8739ae039 = $80e5cf8f12c63ab1$var$PostMessage;
module.exports["default"] = $80e5cf8f12c63ab1$export$2e2bcd8739ae039;

});

parcelRegister("9HehF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jJf3a = parcelRequire("jJf3a");

function $6886c403abc3e03b$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $6886c403abc3e03b$export$f20b867e738a222c;

});

parcelRegister("dsm7I", function(module, exports) {
const $17bb7e3dd1375fe7$export$8c2f2e05ab832914 = 'embeddedConfluenceScrollToHash';
module.exports["SCROLL_TO_HASH_MESSAGE_TYPE"] = $17bb7e3dd1375fe7$export$8c2f2e05ab832914;

});

parcelRegister("6wQcp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4eu1q = parcelRequire("4eu1q");

// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $6aa9e7f0f2c931d4$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $6aa9e7f0f2c931d4$export$4d8f561c32665bbe = (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $42omo.useState)(0);
    const defaultScrollPosition = (0, $42omo.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $42omo.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $4eu1q.useMediaViewerListener)();
    (0, $42omo.useEffect)(()=>{
        const handleScroll = $6aa9e7f0f2c931d4$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
					Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
					it may already have been opened or closed, and we do not have control over the actions that occur
					just before the media viewer is activated (which happens in a different package that we do not manage).
					Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
					This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
					which is misleading since the container height will have been reduced at this point.
					To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
					When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
					inaccuracies associated with saving the scroll position under the conditions of a condensed height.
				*/ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};
module.exports["useGetCurrentScrollPosition"] = $6aa9e7f0f2c931d4$export$4d8f561c32665bbe;

});

parcelRegister("aiCKw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");





var $7pThu = parcelRequire("7pThu");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $1oYQ9 = parcelRequire("1oYQ9");


var $cezNv = parcelRequire("cezNv");

const $7677bd876355e476$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $7677bd876355e476$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $42omo.useMemo)(()=>{
        const isTemplateBrowserEnabled = (0, $cezNv.isInEditorTemplatesPanelEnabled)(allowedFeatures);
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $7677bd876355e476$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $7pThu.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $7pThu.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1oYQ9.Content), {
        ...props,
        contentType: (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");


var $kudeD = parcelRequire("kudeD");


var $cGc86 = parcelRequire("cGc86");

const $9310c72c080a483b$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGc86.UniqueKeyProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $elkSx.PageNotFoundEmptyState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7677bd876355e476$export$1fea75498367c4ac), props))));
};
module.exports["EditPage"] = $9310c72c080a483b$export$1fea75498367c4ac;

});

parcelRegister("8ce0W", function(module, exports) {
$parcel$export(module.exports, "Action", () => $5f7a50a9018faa6a$export$e19cd5f9376f8cee);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $5f7a50a9018faa6a$var$_extends() {
    $5f7a50a9018faa6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f7a50a9018faa6a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $5f7a50a9018faa6a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($5f7a50a9018faa6a$export$e19cd5f9376f8cee || ($5f7a50a9018faa6a$export$e19cd5f9376f8cee = {}));
const $5f7a50a9018faa6a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $5f7a50a9018faa6a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $5f7a50a9018faa6a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $5f7a50a9018faa6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $5f7a50a9018faa6a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $5f7a50a9018faa6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to);
    }
    return $5f7a50a9018faa6a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $5f7a50a9018faa6a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $5f7a50a9018faa6a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $5f7a50a9018faa6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $5f7a50a9018faa6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $5f7a50a9018faa6a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $5f7a50a9018faa6a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $5f7a50a9018faa6a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $5f7a50a9018faa6a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $5f7a50a9018faa6a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $5f7a50a9018faa6a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $5f7a50a9018faa6a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $5f7a50a9018faa6a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $5f7a50a9018faa6a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $5f7a50a9018faa6a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $5f7a50a9018faa6a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($5f7a50a9018faa6a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
        let location = $5f7a50a9018faa6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $5f7a50a9018faa6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
        let location = $5f7a50a9018faa6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $5f7a50a9018faa6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($5f7a50a9018faa6a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($5f7a50a9018faa6a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $5f7a50a9018faa6a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($5f7a50a9018faa6a$var$ResultType || ($5f7a50a9018faa6a$var$ResultType = {}));
const $5f7a50a9018faa6a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $5f7a50a9018faa6a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $5f7a50a9018faa6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($5f7a50a9018faa6a$var$isIndexRoute(route)) {
            let indexRoute = $5f7a50a9018faa6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $5f7a50a9018faa6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $5f7a50a9018faa6a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $5f7a50a9018faa6a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $5f7a50a9018faa6a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $5f7a50a9018faa6a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $5f7a50a9018faa6a$var$flattenRoutes(routes);
    $5f7a50a9018faa6a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $5f7a50a9018faa6a$export$30d21fd6d7295f52(pathname);
        matches = $5f7a50a9018faa6a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $5f7a50a9018faa6a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $5f7a50a9018faa6a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $5f7a50a9018faa6a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $5f7a50a9018faa6a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $5f7a50a9018faa6a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $5f7a50a9018faa6a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $5f7a50a9018faa6a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $5f7a50a9018faa6a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $5f7a50a9018faa6a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $5f7a50a9018faa6a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $5f7a50a9018faa6a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $5f7a50a9018faa6a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $5f7a50a9018faa6a$var$paramRe = /^:[\w-]+$/;
const $5f7a50a9018faa6a$var$dynamicSegmentValue = 3;
const $5f7a50a9018faa6a$var$indexRouteValue = 2;
const $5f7a50a9018faa6a$var$emptySegmentValue = 1;
const $5f7a50a9018faa6a$var$staticSegmentValue = 10;
const $5f7a50a9018faa6a$var$splatPenalty = -2;
const $5f7a50a9018faa6a$var$isSplat = (s)=>s === "*";
function $5f7a50a9018faa6a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($5f7a50a9018faa6a$var$isSplat)) initialScore += $5f7a50a9018faa6a$var$splatPenalty;
    if (index) initialScore += $5f7a50a9018faa6a$var$indexRouteValue;
    return segments.filter((s)=>!$5f7a50a9018faa6a$var$isSplat(s)).reduce((score, segment)=>score + ($5f7a50a9018faa6a$var$paramRe.test(segment) ? $5f7a50a9018faa6a$var$dynamicSegmentValue : segment === "" ? $5f7a50a9018faa6a$var$emptySegmentValue : $5f7a50a9018faa6a$var$staticSegmentValue), initialScore);
}
function $5f7a50a9018faa6a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $5f7a50a9018faa6a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $5f7a50a9018faa6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $5f7a50a9018faa6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $5f7a50a9018faa6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $5f7a50a9018faa6a$export$a5c6d149b50c1d86($5f7a50a9018faa6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $5f7a50a9018faa6a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $5f7a50a9018faa6a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $5f7a50a9018faa6a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $5f7a50a9018faa6a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $5f7a50a9018faa6a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $5f7a50a9018faa6a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $5f7a50a9018faa6a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $5f7a50a9018faa6a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $5f7a50a9018faa6a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $5f7a50a9018faa6a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $5f7a50a9018faa6a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $5f7a50a9018faa6a$var$normalizeSearch(search),
        hash: $5f7a50a9018faa6a$var$normalizeHash(hash)
    };
}
function $5f7a50a9018faa6a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $5f7a50a9018faa6a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $5f7a50a9018faa6a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $5f7a50a9018faa6a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $5f7a50a9018faa6a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $5f7a50a9018faa6a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $5f7a50a9018faa6a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $5f7a50a9018faa6a$var$_extends({}, toArg);
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $5f7a50a9018faa6a$var$getInvalidPathError("?", "pathname", "search", to));
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $5f7a50a9018faa6a$var$getInvalidPathError("#", "pathname", "hash", to));
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $5f7a50a9018faa6a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $5f7a50a9018faa6a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $5f7a50a9018faa6a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $5f7a50a9018faa6a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $5f7a50a9018faa6a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $5f7a50a9018faa6a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $5f7a50a9018faa6a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $5f7a50a9018faa6a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $5f7a50a9018faa6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $5f7a50a9018faa6a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $5f7a50a9018faa6a$export$4051a07651545597(data, init) {
    return new $5f7a50a9018faa6a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $5f7a50a9018faa6a$export$42a99a7a4bc0e76a extends Error {
}
class $5f7a50a9018faa6a$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $5f7a50a9018faa6a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $5f7a50a9018faa6a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $5f7a50a9018faa6a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $5f7a50a9018faa6a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $5f7a50a9018faa6a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $5f7a50a9018faa6a$var$unwrapTrackedPromise(value) {
    if (!$5f7a50a9018faa6a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $5f7a50a9018faa6a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $5f7a50a9018faa6a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $5f7a50a9018faa6a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $5f7a50a9018faa6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $5f7a50a9018faa6a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $5f7a50a9018faa6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $5f7a50a9018faa6a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $5f7a50a9018faa6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $5f7a50a9018faa6a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $5f7a50a9018faa6a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $5f7a50a9018faa6a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $5f7a50a9018faa6a$var$validMutationMethods = new Set($5f7a50a9018faa6a$var$validMutationMethodsArr);
const $5f7a50a9018faa6a$var$validRequestMethodsArr = [
    "get",
    ...$5f7a50a9018faa6a$var$validMutationMethodsArr
];
const $5f7a50a9018faa6a$var$validRequestMethods = new Set($5f7a50a9018faa6a$var$validRequestMethodsArr);
const $5f7a50a9018faa6a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $5f7a50a9018faa6a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $5f7a50a9018faa6a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $5f7a50a9018faa6a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $5f7a50a9018faa6a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $5f7a50a9018faa6a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $5f7a50a9018faa6a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $5f7a50a9018faa6a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $5f7a50a9018faa6a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $5f7a50a9018faa6a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $5f7a50a9018faa6a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $5f7a50a9018faa6a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $5f7a50a9018faa6a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $5f7a50a9018faa6a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $5f7a50a9018faa6a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $5f7a50a9018faa6a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $5f7a50a9018faa6a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$5f7a50a9018faa6a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $5f7a50a9018faa6a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $5f7a50a9018faa6a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $5f7a50a9018faa6a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $5f7a50a9018faa6a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $5f7a50a9018faa6a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($5f7a50a9018faa6a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $5f7a50a9018faa6a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $5f7a50a9018faa6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $5f7a50a9018faa6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $5f7a50a9018faa6a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $5f7a50a9018faa6a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $5f7a50a9018faa6a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $5f7a50a9018faa6a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $5f7a50a9018faa6a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $5f7a50a9018faa6a$var$findNearestBoundary(matches).route.id,
            {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $5f7a50a9018faa6a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($5f7a50a9018faa6a$var$isErrorResult(result) && $5f7a50a9018faa6a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $5f7a50a9018faa6a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $5f7a50a9018faa6a$var$_extends({
            matches: updatedMatches || matches
        }, $5f7a50a9018faa6a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $5f7a50a9018faa6a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $5f7a50a9018faa6a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $5f7a50a9018faa6a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $5f7a50a9018faa6a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $5f7a50a9018faa6a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $5f7a50a9018faa6a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) throw $5f7a50a9018faa6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $5f7a50a9018faa6a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $5f7a50a9018faa6a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($5f7a50a9018faa6a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $5f7a50a9018faa6a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $5f7a50a9018faa6a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $5f7a50a9018faa6a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $5f7a50a9018faa6a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $5f7a50a9018faa6a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $5f7a50a9018faa6a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $5f7a50a9018faa6a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $5f7a50a9018faa6a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $5f7a50a9018faa6a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $5f7a50a9018faa6a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $5f7a50a9018faa6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $5f7a50a9018faa6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $5f7a50a9018faa6a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5f7a50a9018faa6a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $5f7a50a9018faa6a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($5f7a50a9018faa6a$var$isRedirectResult(actionResult) || $5f7a50a9018faa6a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($5f7a50a9018faa6a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $5f7a50a9018faa6a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($5f7a50a9018faa6a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($5f7a50a9018faa6a$var$isDeferredResult(actionResult)) throw $5f7a50a9018faa6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $5f7a50a9018faa6a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $5f7a50a9018faa6a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $5f7a50a9018faa6a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $5f7a50a9018faa6a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $5f7a50a9018faa6a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $5f7a50a9018faa6a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $5f7a50a9018faa6a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $5f7a50a9018faa6a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $5f7a50a9018faa6a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $5f7a50a9018faa6a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5f7a50a9018faa6a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $5f7a50a9018faa6a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) result = await $5f7a50a9018faa6a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!$5f7a50a9018faa6a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $5f7a50a9018faa6a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $5f7a50a9018faa6a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $5f7a50a9018faa6a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace : $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $5f7a50a9018faa6a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($5f7a50a9018faa6a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $5f7a50a9018faa6a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $5f7a50a9018faa6a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $5f7a50a9018faa6a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $5f7a50a9018faa6a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $5f7a50a9018faa6a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($5f7a50a9018faa6a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $5f7a50a9018faa6a$var$ResultType.redirect,
                response: $5f7a50a9018faa6a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $5f7a50a9018faa6a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $5f7a50a9018faa6a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $5f7a50a9018faa6a$var$ResultType.error,
                    error: $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $5f7a50a9018faa6a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $5f7a50a9018faa6a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $5f7a50a9018faa6a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $5f7a50a9018faa6a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $5f7a50a9018faa6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $5f7a50a9018faa6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $5f7a50a9018faa6a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $5f7a50a9018faa6a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $5f7a50a9018faa6a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $5f7a50a9018faa6a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$5f7a50a9018faa6a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $5f7a50a9018faa6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $5f7a50a9018faa6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $5f7a50a9018faa6a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $5f7a50a9018faa6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $5f7a50a9018faa6a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $5f7a50a9018faa6a$export$4d0306f8f6a4585b = Symbol("deferred");
function $5f7a50a9018faa6a$export$3336b097a6fbc59a(routes, opts) {
    $5f7a50a9018faa6a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $5f7a50a9018faa6a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $5f7a50a9018faa6a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $5f7a50a9018faa6a$var$createLocation("", $5f7a50a9018faa6a$export$fe53371bee54353d(url), null, "default");
        let matches = $5f7a50a9018faa6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$5f7a50a9018faa6a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($5f7a50a9018faa6a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $5f7a50a9018faa6a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $5f7a50a9018faa6a$var$createLocation("", $5f7a50a9018faa6a$export$fe53371bee54353d(url), null, "default");
        let matches = $5f7a50a9018faa6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$5f7a50a9018faa6a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $5f7a50a9018faa6a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $5f7a50a9018faa6a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $5f7a50a9018faa6a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($5f7a50a9018faa6a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$5f7a50a9018faa6a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $5f7a50a9018faa6a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($5f7a50a9018faa6a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $5f7a50a9018faa6a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $5f7a50a9018faa6a$var$isResponse(result) ? result : $5f7a50a9018faa6a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($5f7a50a9018faa6a$var$isDataStrategyResult(e) && $5f7a50a9018faa6a$var$isResponse(e.result)) {
                if (e.type === $5f7a50a9018faa6a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($5f7a50a9018faa6a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $5f7a50a9018faa6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($5f7a50a9018faa6a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5f7a50a9018faa6a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $5f7a50a9018faa6a$var$_extends({}, context, {
                statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $5f7a50a9018faa6a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $5f7a50a9018faa6a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $5f7a50a9018faa6a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $5f7a50a9018faa6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $5f7a50a9018faa6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $5f7a50a9018faa6a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $5f7a50a9018faa6a$var$callDataStrategyImpl(dataStrategy || $5f7a50a9018faa6a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($5f7a50a9018faa6a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $5f7a50a9018faa6a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($5f7a50a9018faa6a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $5f7a50a9018faa6a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $5f7a50a9018faa6a$export$fec11da027c70692(routes, context, error) {
    let newContext = $5f7a50a9018faa6a$var$_extends({}, context, {
        statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $5f7a50a9018faa6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $5f7a50a9018faa6a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $5f7a50a9018faa6a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $5f7a50a9018faa6a$export$cae722b0cc860f13(to ? to : ".", $5f7a50a9018faa6a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $5f7a50a9018faa6a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $5f7a50a9018faa6a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $5f7a50a9018faa6a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $5f7a50a9018faa6a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $5f7a50a9018faa6a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$5f7a50a9018faa6a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$5f7a50a9018faa6a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $5f7a50a9018faa6a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $5f7a50a9018faa6a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $5f7a50a9018faa6a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$5f7a50a9018faa6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$5f7a50a9018faa6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $5f7a50a9018faa6a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $5f7a50a9018faa6a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $5f7a50a9018faa6a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $5f7a50a9018faa6a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $5f7a50a9018faa6a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $5f7a50a9018faa6a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $5f7a50a9018faa6a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $5f7a50a9018faa6a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $5f7a50a9018faa6a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($5f7a50a9018faa6a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $5f7a50a9018faa6a$var$shouldRevalidateLoader(match, $5f7a50a9018faa6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $5f7a50a9018faa6a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $5f7a50a9018faa6a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $5f7a50a9018faa6a$var$shouldRevalidateLoader(fetcherMatch, $5f7a50a9018faa6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $5f7a50a9018faa6a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $5f7a50a9018faa6a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $5f7a50a9018faa6a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $5f7a50a9018faa6a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$5f7a50a9018faa6a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $5f7a50a9018faa6a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$5f7a50a9018faa6a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $5f7a50a9018faa6a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $5f7a50a9018faa6a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $5f7a50a9018faa6a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$5f7a50a9018faa6a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $5f7a50a9018faa6a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $5f7a50a9018faa6a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $5f7a50a9018faa6a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $5f7a50a9018faa6a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $5f7a50a9018faa6a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $5f7a50a9018faa6a$var$ResultType.data,
                result: undefined
            });
        };
        return $5f7a50a9018faa6a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $5f7a50a9018faa6a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $5f7a50a9018faa6a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $5f7a50a9018faa6a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $5f7a50a9018faa6a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($5f7a50a9018faa6a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: e
            };
        }
        if (type === $5f7a50a9018faa6a$var$ResultType.error) return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: new $5f7a50a9018faa6a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $5f7a50a9018faa6a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $5f7a50a9018faa6a$var$ResultType.error) {
        if ($5f7a50a9018faa6a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $5f7a50a9018faa6a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: new $5f7a50a9018faa6a$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: result,
            statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($5f7a50a9018faa6a$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $5f7a50a9018faa6a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($5f7a50a9018faa6a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $5f7a50a9018faa6a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $5f7a50a9018faa6a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $5f7a50a9018faa6a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $5f7a50a9018faa6a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $5f7a50a9018faa6a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $5f7a50a9018faa6a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $5f7a50a9018faa6a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $5f7a50a9018faa6a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($5f7a50a9018faa6a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $5f7a50a9018faa6a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $5f7a50a9018faa6a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $5f7a50a9018faa6a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $5f7a50a9018faa6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!$5f7a50a9018faa6a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $5f7a50a9018faa6a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($5f7a50a9018faa6a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $5f7a50a9018faa6a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $5f7a50a9018faa6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $5f7a50a9018faa6a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($5f7a50a9018faa6a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $5f7a50a9018faa6a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($5f7a50a9018faa6a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $5f7a50a9018faa6a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $5f7a50a9018faa6a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $5f7a50a9018faa6a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $5f7a50a9018faa6a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $5f7a50a9018faa6a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $5f7a50a9018faa6a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $5f7a50a9018faa6a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $5f7a50a9018faa6a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $5f7a50a9018faa6a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $5f7a50a9018faa6a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $5f7a50a9018faa6a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(path) : path;
    return $5f7a50a9018faa6a$export$fe53371bee54353d($5f7a50a9018faa6a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $5f7a50a9018faa6a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $5f7a50a9018faa6a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $5f7a50a9018faa6a$var$ResultType.data || result.type === $5f7a50a9018faa6a$var$ResultType.error);
}
function $5f7a50a9018faa6a$var$isRedirectDataStrategyResultResult(result) {
    return $5f7a50a9018faa6a$var$isResponse(result.result) && $5f7a50a9018faa6a$var$redirectStatusCodes.has(result.result.status);
}
function $5f7a50a9018faa6a$var$isDeferredResult(result) {
    return result.type === $5f7a50a9018faa6a$var$ResultType.deferred;
}
function $5f7a50a9018faa6a$var$isErrorResult(result) {
    return result.type === $5f7a50a9018faa6a$var$ResultType.error;
}
function $5f7a50a9018faa6a$var$isRedirectResult(result) {
    return (result && result.type) === $5f7a50a9018faa6a$var$ResultType.redirect;
}
function $5f7a50a9018faa6a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $5f7a50a9018faa6a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $5f7a50a9018faa6a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $5f7a50a9018faa6a$var$isRedirectResponse(result) {
    if (!$5f7a50a9018faa6a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $5f7a50a9018faa6a$var$isValidMethod(method) {
    return $5f7a50a9018faa6a$var$validRequestMethods.has(method.toLowerCase());
}
function $5f7a50a9018faa6a$var$isMutationMethod(method) {
    return $5f7a50a9018faa6a$var$validMutationMethods.has(method.toLowerCase());
}
async function $5f7a50a9018faa6a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$5f7a50a9018faa6a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($5f7a50a9018faa6a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $5f7a50a9018faa6a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $5f7a50a9018faa6a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $5f7a50a9018faa6a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $5f7a50a9018faa6a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $5f7a50a9018faa6a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $5f7a50a9018faa6a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $5f7a50a9018faa6a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $5f7a50a9018faa6a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $5f7a50a9018faa6a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $5f7a50a9018faa6a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $5f7a50a9018faa6a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $5f7a50a9018faa6a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $5f7a50a9018faa6a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $5f7a50a9018faa6a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $5f7a50a9018faa6a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $5f7a50a9018faa6a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $5f7a50a9018faa6a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $5f7a50a9018faa6a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($5f7a50a9018faa6a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $5f7a50a9018faa6a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($5f7a50a9018faa6a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}
module.exports["createMemoryHistory"] = $5f7a50a9018faa6a$export$2b76ad033c6e6d08;
module.exports["createPath"] = $5f7a50a9018faa6a$export$fe53371bee54353d;
module.exports["parsePath"] = $5f7a50a9018faa6a$export$8ccf933b0513f8d0;
module.exports["UNSAFE_invariant"] = $5f7a50a9018faa6a$export$3e9cee6b33872309;
module.exports["matchRoutes"] = $5f7a50a9018faa6a$export$2708184779ceb39d;
module.exports["stripBasename"] = $5f7a50a9018faa6a$export$b69e3301ce081aa3;
module.exports["UNSAFE_decodePath"] = $5f7a50a9018faa6a$export$30d21fd6d7295f52;
module.exports["UNSAFE_convertRouteMatchToUiMatch"] = $5f7a50a9018faa6a$export$b3fac024fad9e8ff;
module.exports["joinPaths"] = $5f7a50a9018faa6a$export$86d9a7913e44197e;
module.exports["matchPath"] = $5f7a50a9018faa6a$export$81336c211d5ff295;
module.exports["UNSAFE_getResolveToMatches"] = $5f7a50a9018faa6a$export$a5784978eca585fa;
module.exports["resolveTo"] = $5f7a50a9018faa6a$export$cae722b0cc860f13;
module.exports["AbortedDeferredError"] = $5f7a50a9018faa6a$export$42a99a7a4bc0e76a;
module.exports["isRouteErrorResponse"] = $5f7a50a9018faa6a$export$972111febbeef05b;
module.exports["IDLE_BLOCKER"] = $5f7a50a9018faa6a$export$386d57f03f0b2883;
module.exports["createRouter"] = $5f7a50a9018faa6a$export$baddd0131ee8c05b;

});

parcelRegister("jNfGN", function(module, exports) {
const $b46edb367a256dec$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $b46edb367a256dec$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $b46edb367a256dec$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $b46edb367a256dec$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $b46edb367a256dec$export$65b723bb995d4fb6,
    VIEW_PAGE: $b46edb367a256dec$export$9257b5b55c8e2555,
    VIEW_BLOG: $b46edb367a256dec$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $b46edb367a256dec$export$bd2c9bb170b3681d,
    WHITEBOARD: $b46edb367a256dec$export$fbefbcc1445e8d74
};
const $b46edb367a256dec$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};
module.exports["EDIT_PAGE_EMBED"] = $b46edb367a256dec$export$e63a462ee45b57cf;
module.exports["EDIT_PAGE_V2"] = $b46edb367a256dec$export$7b1285e36c635f1f;
module.exports["VIEW_PAGE"] = $b46edb367a256dec$export$9257b5b55c8e2555;
module.exports["VIEW_BLOG"] = $b46edb367a256dec$export$91f49e7b30a9d34;
module.exports["VIEW_BLOG_DATE_LEGACY"] = $b46edb367a256dec$export$bd2c9bb170b3681d;
module.exports["WHITEBOARD"] = $b46edb367a256dec$export$fbefbcc1445e8d74;
module.exports["namedRoutes"] = $b46edb367a256dec$export$d4971375353d0454;
module.exports["EMBEDDED_PARENT_PRODUCTS"] = $b46edb367a256dec$export$5c59aa0922e65f1a;

});

parcelRegister("4eu1q", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5c5762ed3f356c35$export$6d8905296959d5f5 = ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $42omo.useState)(false);
    const mediaMessageListener = (0, $42omo.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};
module.exports["useMediaViewerListener"] = $5c5762ed3f356c35$export$6d8905296959d5f5;

});


$parcel$global.rlb("4SCW2")
//# sourceMappingURL=FullPageEditorComponent.5df7267a.js.map
